/** Thai and English text for the TMS app. Keys follow the resource layout. */
export const th = {
  app: { name: 'TMS', description: 'บิลขนส่ง จ่ายงาน เที่ยวรถ และรอบส่ง' },
  nav: {
    overview: 'ภาพรวมวันนี้',
    counter: 'หน้าร้าน',
    transport: 'เดินรถ',
    shipments: 'งานเหมาคัน',
    trips: 'เที่ยวรถ',
    runs: 'รอบส่ง',
    manifests: 'ใบคุมรถ',
    waybills: 'บิลงานขนส่ง',
    receipts: 'ใบเสร็จ',
    refunds: 'ใบคืนเงิน',
    unpaid: 'ปลายทางยังไม่รับเงิน',
    payBills: 'รับชำระหลายบิล',
    contacts: 'ผู้ติดต่อ',
    products: 'สินค้า',
    settings: 'ข้อมูลหลัก',
    late: 'ล่าช้า',
    vehicles: 'รถ',
    drivers: 'พนักงานประจำรถ',
    reports: 'รายงาน',
  },
  shipment: {
    title: 'งานเหมาคัน',
    plural: 'งานเหมาคัน',
    create: 'สร้างงานเหมาคัน',
    fields: {
      number: 'เลขที่งาน',
      customerId: 'ลูกค้า',
      pickupDate: 'วันที่รับสินค้า',
      pickupTime: 'นัดรับ',
      origin: 'ต้นทาง',
      destination: 'ปลายทาง',
      distanceKm: 'ระยะทาง (กม.)',
      cargo: 'สินค้า',
      pallets: 'พาเลท',
      weightKg: 'น้ำหนัก (กก.)',
      vehicleId: 'รถ',
      driverId: 'คนขับ',
      helperIds: 'ผู้ช่วยคนขับ',
      contractorPay: 'ค่าจ้างรถร่วม',
      contractorBillId: 'ใบตั้งหนี้ค่าเที่ยว',
      status: 'สถานะ',
      eta: 'ถึงโดยประมาณ',
      price: 'ค่าขนส่ง (บาท)',
      services: 'บริการเสริม',
      servicesFee: 'ค่าบริการเสริม',
      total: 'ยอดรวม',
      paid: 'รับเงินแล้ว',
      paymentStatus: 'การชำระ',
      receiptIds: 'ใบเสร็จ',
      termsId: 'เงื่อนไขการขนส่ง',
      notes: 'หมายเหตุ',
      deliveredAt: 'ส่งสำเร็จเมื่อ',
      driverUserId: 'บัญชีคนขับ',
      route: 'เส้นทาง',
      etaShort: 'ETA',
    },
    options: {
      status: {
        draft: 'ร่าง',
        pending: 'รอจ่ายงาน',
        assigned: 'จ่ายงานแล้ว',
        picking: 'กำลังรับสินค้า',
        in_transit: 'กำลังขนส่ง',
        delivered: 'ส่งสำเร็จ',
        cancelled: 'ยกเลิก',
      },
      paymentStatus: { unpaid: 'ยังไม่ชำระ', partial: 'ชำระบางส่วน', paid: 'ชำระแล้ว' },
    },
    sections: {
      main: 'ข้อมูลงาน',
      route: 'เส้นทาง',
      cargo: 'สินค้า',
      assign: 'การจ่ายงาน',
      services: 'บริการเสริม',
      other: 'หมายเหตุ',
    },
    actions: {
      assign: 'จ่ายงาน',
      start: 'เริ่มงาน',
      pickedUp: 'รับสินค้าแล้ว',
      deliver: 'ส่งสำเร็จ',
      deliverWithPhoto: 'ส่งสำเร็จ · ถ่ายรูป',
      call: 'โทร',
      navigate: 'นำทาง',
    },
    late: 'ล่าช้า {{minutes}} นาที',
    remainingKm: 'เหลือ {{km}} กม.',
    unassigned: 'ยังไม่ระบุรถ',
    chooseVehicle: 'เลือกรถ',
    lateChip: 'ล่าช้า',
    statusCard: 'สถานะงาน',
    nextStep: 'ขั้นถัดไป',
    setStatus: 'เปลี่ยนเป็น “{{status}}”',
    printJob: 'พิมพ์ใบงาน',
    /** Its customer pays on receipts of TMS, as a waybill's payer does: before the truck goes too, in part */
    pay: {
      title: 'การชำระเงิน',
      dialog: 'รับเงินงาน',
      take: 'รับเงิน',
      owed: 'ค้างชำระ',
      none: 'ยังไม่ได้รับเงิน',
      ahead: 'รับก่อนรถออกได้ (มัดจำ) และรับทีละส่วนได้ ทุกครั้งออกใบเสร็จ',
      partial: 'รับบางส่วน งานนี้ค้างอีก',
      noTotal: 'ใส่ค่าขนส่งของงานก่อนรับเงิน',
      submitFirst: 'เสนองานก่อนรับเงิน',
    },
    jobSheet: 'ใบงานขนส่ง',
    submitFirst: 'กด "บันทึกและเสนอ" ยืนยันงานก่อน แล้วจึงจ่ายรถและพิมพ์ใบงานได้',
    receiverSign: 'ผู้รับสินค้า',
    driverSign: 'พนักงานขับรถ',
    dispatcherSign: 'ผู้จ่ายงาน',
  },
  assign: {
    title: 'จ่ายงาน',
    job: 'งานที่รอจ่าย',
    vehicle: 'รถ',
    driver: 'คนขับ',
    confirm: 'จ่ายงาน',
    done: 'จ่ายงาน {{number}} ให้ {{plate}} แล้ว',
    noPending: 'ไม่มีงานที่รอจ่าย',
    contractorPay: 'ค่าจ้างรถร่วมเที่ยวนี้',
    contractorHint: 'คนขับรถร่วมขับได้เฉพาะรถของตัวเอง เมื่อส่งสำเร็จระบบตั้งหนี้ค่าเที่ยวให้ หัก ณ ที่จ่าย 1%',
  },
  waybill: {
    title: 'บิลงานขนส่ง',
    plural: 'บิลงานขนส่ง',
    create: 'สร้างบิลงานขนส่ง',
    fields: {
      number: 'เลขที่บิล',
      bookedAt: 'เวลาจอง',
      payer: 'ผู้ชำระค่าขนส่ง',
      originBranchId: 'สาขาที่รับฝาก',
      originMode: 'รูปแบบต้นทาง',
      senderId: 'ผู้ติดต่อ (ผู้ส่ง)',
      senderName: 'ผู้ส่ง',
      senderPhone: 'เบอร์ผู้ส่ง',
      senderIdCard: 'เลขบัตร/พาสปอร์ตผู้ส่ง',
      senderAddress: 'ที่อยู่ผู้ส่ง',
      senderProvince: 'ตำบล อำเภอ จังหวัด',
      senderDistrict: 'อำเภอผู้ส่ง',
      senderSubdistrict: 'ตำบลผู้ส่ง',
      senderPostcode: 'รหัสไปรษณีย์ผู้ส่ง',
      senderBusinessType: 'ประเภทธุรกิจผู้ส่ง',
      destMode: 'รูปแบบปลายทาง',
      destBranchId: 'สาขาปลายทาง',
      receiverId: 'ผู้ติดต่อ (ผู้รับ)',
      receiverName: 'ผู้รับ',
      receiverPhone: 'เบอร์ผู้รับ',
      receiverAddress: 'ที่อยู่ผู้รับ',
      receiverProvince: 'ตำบล อำเภอ จังหวัด',
      receiverDistrict: 'อำเภอผู้รับ',
      receiverSubdistrict: 'ตำบลผู้รับ',
      receiverPostcode: 'รหัสไปรษณีย์ผู้รับ',
      receiverBusinessType: 'ประเภทธุรกิจผู้รับ',
      items: 'พัสดุ',
      pieces: 'จำนวนชิ้น',
      weightKg: 'น้ำหนักรวม (กก.)',
      services: 'บริการเสริม',
      servicesFee: 'ค่าบริการเสริม',
      fee: 'ยอดรวม',
      termsId: 'เงื่อนไขการขนส่ง',
      route: 'เส้นทาง',
      currentBranchId: 'อยู่ที่สาขา',
      status: 'สถานะ',
      paymentStatus: 'การชำระ',
      senderPaid: 'ผู้ส่งชำระแล้ว',
      receiverPaid: 'ผู้รับชำระแล้ว',
      receiptIds: 'ใบเสร็จ',
      trackingCode: 'รหัสติดตาม',
      returnId: 'บิลตีกลับ',
      returnOfId: 'ตีกลับจากบิล',
      receiverMoved: 'ยอดปลายทางย้ายไปบิลตีกลับ',
      declaredValue: 'มูลค่าสินค้า (บาท)',
      reference: 'เลขอ้างอิงลูกค้า',
      notes: 'หมายเหตุ',
      signing: 'ผู้ส่งเซ็นเงื่อนไข',
      provinceColumn: 'จังหวัดผู้รับ',
    },
    options: {
      payer: { sender: 'ต้นทาง (ผู้ส่ง)', receiver: 'ปลายทาง (ผู้รับ)' },
      originMode: { dropoff: 'ลูกค้าเข้ามาส่งที่หน้าร้าน', pickup: 'เข้าไปรับที่ผู้ส่ง' },
      destMode: { door: 'จัดส่งตามที่อยู่', branch: 'ผู้รับมารับที่สาขา' },
      status: {
        draft: 'ร่าง',
        received: 'รับฝากแล้ว',
        in_transit: 'อยู่ระหว่างขนส่ง',
        at_branch: 'ถึงสาขา',
        out_for_delivery: 'กำลังนำส่ง',
        ready_for_pickup: 'รอผู้รับมารับ',
        delivered: 'ส่งสำเร็จ',
        returned: 'ตีกลับ',
        cancelled: 'ยกเลิก',
      },
      paymentStatus: {
        unpaid: 'ยังไม่ชำระ',
        partial: 'ชำระบางส่วน',
        paid: 'ชำระแล้ว',
        overpaid: 'รอคืนเงิน',
        moved: 'ย้ายยอดไปบิลตีกลับ',
      },
    },
    sections: {
      booking: 'การจอง',
      sender: 'ผู้ส่ง',
      receiver: 'ผู้รับ',
      items: 'พัสดุ',
      services: 'บริการเสริม',
      extra: 'ข้อมูลเพิ่มเติม',
    },
    chips: { owing: 'ค้างชำระ' },
    tabs: { main: 'หลัก', extra: 'ข้อมูลเพิ่มเติม' },
    steps: { sender: 'ผู้ส่ง', receiver: 'ผู้รับ', items: 'พัสดุและค่าส่ง', review: 'ตรวจทานก่อนบันทึก' },
    review: {
      edit: 'แก้ไข',
      pickupAt: 'รับที่สาขา {{branch}}',
      fromBranch: 'ส่งที่ {{branch}}',
      pickedUp: 'ไปรับถึงที่',
      check: 'ตรวจชื่อ เบอร์ และที่อยู่ให้ตรงกับลูกค้า แล้วกดบันทึก',
    },
    item: {
      name: 'สินค้า',
      qty: 'จำนวน',
      unit: 'หน่วย',
      weightKg: 'น้ำหนัก/ชิ้น (กก.)',
      rate: 'อัตรา',
      amount: 'ค่าขนส่ง',
      add: 'เพิ่มรายการ',
      remove: 'ลบรายการ',
      placeholder: 'พิมพ์ชื่อสินค้า',
    },
    summary: {
      title: 'สรุป',
      route: 'เส้นทาง',
      noRoute: 'ยังไม่มีเส้นทางรถไปสาขาปลายทาง ตั้งค่าที่หน้า "สาขา"',
      noBranch: 'ยังไม่มีสาขาที่ส่งถึงพื้นที่นี้ เลือกสาขาปลายทางเอง หรือเพิ่มพื้นที่ส่งให้สาขา',
      notDelivered: '{{branch}} ไม่ส่งถึง {{place}} ให้ผู้รับมารับที่สาขา',
      pickBranch: 'เลือกสาขาที่ผู้รับจะมารับ',
      deliver: 'จัดส่งถึงผู้รับ',
      collect: 'ผู้รับมารับที่สาขา',
      direct: 'ส่งเองในพื้นที่สาขา',
      auto: 'อัตโนมัติ: {{name}}',
      needArea: 'ใส่ตำบล อำเภอ จังหวัดของผู้รับ แล้วระบบจะหาสาขาปลายทางและเส้นทางให้',
      collectAt: 'สาขาที่ผู้รับมารับ',
    },
    contact: {
      placeholder: 'พิมพ์ชื่อหรือเบอร์โทร',
      hint: 'เลือกจากสมุดผู้ติดต่อ หรือพิมพ์ชื่อใหม่ ระบบบันทึกให้',
      open: 'เปิดผู้ติดต่อ',
      linked: 'จากสมุดผู้ติดต่อ',
      new: 'ใหม่',
      newHint: 'ยังไม่อยู่ในสมุดผู้ติดต่อ ระบบเพิ่มให้เมื่อเสนอบิล',
      hasNotes: 'มีสิ่งที่ควรรู้',
      goodToKnow: 'สิ่งที่ควรรู้',
      add: 'เพิ่มสิ่งที่ควรรู้',
      edit: 'แก้สิ่งที่ควรรู้',
      editTitle: 'สิ่งที่ควรรู้ของ {{name}}',
      notesPlaceholder: 'เช่น โทรก่อนถึง ซอยแคบ รถ 6 ล้อเข้าไม่ได้ ปิดวันอาทิตย์',
      savedTo: 'บันทึกไว้ที่ผู้ติดต่อ บิลทุกใบของเขาและรอบส่งเห็นด้วย',
      saved: 'บันทึกสิ่งที่ควรรู้แล้ว',
      atHouse: 'เคยส่งที่นี่ในชื่อ {{name}}',
      didYouMean: 'หรือคุณหมายถึง',
      or: 'หรือ',
      why: { phone: 'เบอร์เดียวกัน', name: 'ชื่อคล้ายกัน' },
      useThis: 'ใช้คนนี้',
      sameTitle: '{{party}} "{{name}}" คือคนเดียวกับในสมุดไหม',
      sameBody: 'ถ้าใช่ บิลจะผูกกับผู้ติดต่อเดิม สิ่งที่ควรรู้ของเขาตามมา และสมุดไม่มีชื่อซ้ำ',
      notSame: 'ไม่ใช่ เพิ่มเป็นคนใหม่',
    },
    area: { placeholder: 'พิมพ์ตำบล อำเภอ จังหวัด หรือรหัสไปรษณีย์', none: 'ไม่พบพื้นที่นี้' },
    actions: {
      pay: 'รับเงิน',
      print: 'พิมพ์บิล',
      printReceipt: 'พิมพ์ใบเสร็จ',
      openReceipt: 'เปิดใบเสร็จ',
      handover: 'ส่งสำเร็จ',
      undeliver: 'ยกเลิกส่งมอบ',
      return: 'ตีกลับ',
      notDelivered: 'ส่งไม่สำเร็จ',
      copyTrackLink: 'คัดลอกลิงก์ติดตาม',
    },
    trackLink: {
      copied: 'คัดลอกลิงก์ติดตามแล้ว ส่งให้ลูกค้าทางไลน์ได้เลย',
      hint: 'ลูกค้าเปิดดูสถานะบิลได้เองโดยไม่ต้องเข้าระบบ',
    },
    return: {
      title: 'ตีกลับบิล {{number}}',
      intro: 'ของจะกลับไปที่ {{origin}} ในบิลใหม่ ผู้ส่งเดิมเป็นผู้รับและจ่ายค่าขนส่งขากลับ',
      reason: 'เหตุผลที่ตีกลับ',
      note: 'รายละเอียด',
      freight: 'ค่าขนส่งขากลับ (บาท)',
      freightHint: 'ใส่ 0 ถ้าบริษัทรับผิดชอบเอง',
      moved: 'ค่าขนส่งขาไปที่ผู้รับยังไม่จ่าย {{amount}} บาท ย้ายไปเก็บกับผู้ส่งในบิลตีกลับ',
      total: 'บิลตีกลับเก็บผู้ส่งรวม {{amount}} บาท',
      confirm: 'ตีกลับ',
      done: 'ตีกลับแล้ว เป็นบิล {{number}}',
      returnedAs: 'ตีกลับเป็นบิล {{number}}',
      returnOf: 'ตีกลับจากบิล {{number}}',
      /** The return bill's charge lines, written on it */
      lines: { freight: 'ค่าขนส่งตีกลับ', carried: 'ค่าขนส่งขาไป บิล {{number}}' },
      goodsAt: 'ของอยู่ที่สาขา',
      goodsAtMine: 'ของอยู่ที่ {{branch}} (สาขาของคุณ)',
      onTruck: 'อยู่บนรถ',
      onRun: 'อยู่ในรอบส่ง',
      atBranch: 'อยู่ที่ {{branch}}',
      catchUp: 'ในระบบบิลนี้ยัง{{now}} บันทึกแล้วระบบจะปรับให้ของอยู่ที่ {{branch}}',
    },
    notDelivered: {
      title: 'ส่งไม่สำเร็จ บิล {{number}}',
      reason: 'เหตุผลที่ส่งไม่สำเร็จ',
      intro: 'บิลกลับไปรอรอบส่งถัดไปที่สาขาที่ของอยู่',
      introRun: 'บิลอยู่ในรอบส่ง ระบบบันทึกส่งไม่สำเร็จในรอบนั้น แล้วบิลกลับไปรอที่สาขาของรอบ',
      confirm: 'บันทึกส่งไม่สำเร็จ',
      done: 'บันทึกบิล {{number}} ส่งไม่สำเร็จแล้ว',
    },
    handover: {
      payFirst: 'ผู้รับยังต้องจ่ายค่าขนส่ง รับเงินแล้วติ๊ก "ลูกค้ารับของแล้ว" บิลจะส่งมอบพร้อมกัน',
      done: 'ส่งมอบบิล {{number}} แล้ว',
      screenTitle: 'ผู้รับเซ็นรับพัสดุ',
      screenStatement: 'ข้าพเจ้าได้รับพัสดุตามบิล {{number}} จำนวน {{pieces}} ชิ้นแล้ว',
    },
    undeliver: {
      title: 'ยกเลิกส่งมอบ บิล {{number}}',
      intro: 'ใช้เมื่อบันทึกส่งมอบผิดบิลหรือผิดคน ลายเซ็นผู้รับจะถูกลบ ส่วนประวัติการส่งมอบยังอยู่ในการเดินทางของบิล',
      backOnRun: 'บิลกลับไปออกส่งในรอบ {{number}} บันทึกผลส่งใหม่ได้',
      backHere: 'บิลกลับไปออกส่งในรอบนี้ บันทึกผลส่งใหม่ได้',
      backAt: 'บิลกลับไปรอที่ {{branch}}',
      note: 'เหตุผลที่ยกเลิก',
      confirm: 'ยกเลิกส่งมอบ',
      done: 'ยกเลิกส่งมอบบิล {{number}} แล้ว',
    },
    pay: {
      title: 'รับเงินค่าขนส่ง',
      amount: 'ยอดที่ต้องชำระ',
      method: 'วิธีชำระ',
      received: 'รับเงินมา',
      change: 'เงินทอน',
      short: 'รับเงินไม่พอ',
      partial: 'รับบางส่วน บิลนี้ค้างอีก',
      confirmPartial: 'รับบางส่วนและออกใบเสร็จ',
      confirm: 'รับเงินและออกใบเสร็จ',
      done: 'ออกใบเสร็จ {{number}} แล้ว',
      atDestination: 'ผู้รับชำระที่ปลายทาง',
      submitFirst: 'กด "บันทึกและเสนอ" แล้วจึงรับเงินและพิมพ์บิลได้',
      exact: 'พอดี',
      shortBy: 'ขาดอีก {{amount}} บาท',
      bills: 'บิลที่รับเงิน ({{count}})',
      removeBill: 'เอาบิลนี้ออก',
      sameCustomer: 'ยังไม่ชำระ ลูกค้าคนเดียวกัน',
      paySelected: 'รับเงิน ({{count}})',
      payerRequired: 'บิลมีผู้ชำระหลายคน ระบุชื่อผู้ชำระบนใบเสร็จ',
      mixedPayers: 'รวม {{count}} ผู้ชำระ',
      groupSender: 'ผู้ส่งจ่าย (ต้นทาง)',
      groupReceiver: 'ผู้รับจ่าย (ปลายทาง)',
      switchToReceiver: 'บิลนี้ตั้งให้ต้นทางจ่าย เปลี่ยนเป็นปลายทางจ่ายแล้วรับเงินที่นี่',
      switchToSender: 'บิลนี้ตั้งให้ปลายทางจ่าย เปลี่ยนเป็นต้นทางจ่ายแล้วรับเงินที่นี่',
      elsewhere: 'รับเงินที่สาขานี้ไม่ได้ (บิลของสาขาอื่น)',
      paidPartSender: 'ผู้ส่งจ่ายไปบางส่วนแล้ว เปลี่ยนผู้ชำระไม่ได้ รับที่เหลือที่สาขาต้นทางหรือสำนักงานใหญ่',
      paidPartReceiver: 'ผู้รับจ่ายไปบางส่วนแล้ว เปลี่ยนผู้ชำระไม่ได้ รับที่เหลือที่สาขาปลายทางหรือสำนักงานใหญ่',
      searchBill: 'เพิ่มบิล: พิมพ์เลขบิล ชื่อ หรือเบอร์โทร',
      transferred: 'ยอดโอน',
      delivered: 'ลูกค้ารับของแล้ว (บิลเป็นส่งสำเร็จ)',
      receiptOf: 'รับเงินที่สาขา {{branch}} เงินอยู่ในถุงเงินของคุณ',
      receiptFor: 'ใบเสร็จของสาขา {{branch}} เงินสดเข้าถุงเงินของ {{name}}',
      holder: 'รับเงินแทน',
      holderNone: 'ตัวเอง',
      paidOn: 'วันที่ลูกค้าจ่าย',
      noBranch: 'บัญชีของคุณยังไม่มีสาขาประจำ รับเงินไม่ได้',
      over: 'โอนเกิน',
      overTransfer: 'ยอดโอนเกินยอดที่ต้องชำระ {{amount}} บาท',
      shareOf: '{{side}} {{amount}} จาก {{fee}}',
    },
    parts: {
      sender: 'ต้นทางจ่าย',
      receiver: 'ปลายทางจ่าย',
      paid: 'ชำระแล้ว',
      owed: 'ค้าง',
    },
    print: {
      original: 'ต้นฉบับ',
      copy: 'สำเนา',
      paper: 'ขนาดกระดาษ',
      a4Hint: 'แผ่นละ 2 ใบ ตัดครึ่งตามเส้นประ',
      a5Hint: 'แผ่นละใบ วางแนวนอน',
      paperSheets: 'ใช้กระดาษ {{count}} แผ่น',
      withOriginal: 'พิมพ์ต้นฉบับ',
      copies: 'จำนวนสำเนา',
      sheets: 'พิมพ์ {{count}} ใบ',
      scan: 'เปิดบิลในแอป',
      track: 'ติดตามพัสดุ',
      senderSign: 'ผู้ส่ง',
      staffSign: 'พนักงานรับฝาก',
      declared: 'มูลค่าที่แจ้ง',
      payAt: 'ชำระที่',
      pieces: 'ชิ้น',
      goods: 'รวม {{pieces}} ชิ้น · {{kg}} กก.',
      service: 'บริการเสริม',
      paidStamp: 'ชำระแล้ว',
      via: 'ผ่าน {{stops}}',
    },
  },
  payBills: {
    title: 'รับชำระหลายบิล',
    subtitle: 'ค้นหาบิลของลูกค้า ใส่ยอดที่รับ จ่ายไม่ครบก็ได้ ระบบตัดบิลเก่าก่อน',
    bills: 'บิลที่ชำระ',
    search: 'ค้นหาบิล: เลขบิล ชื่อ หรือเบอร์โทร',
    empty: 'ยังไม่ได้เลือกบิล ค้นหาด้วยเบอร์โทรเพื่อดึงบิลค้างทั้งหมดของลูกค้า',
    owes: 'ค้าง',
    pay: 'ชำระ',
    others: 'บิลค้างอื่นของ {{name}}',
    addAll: 'เพิ่มทั้งหมด ({{count}})',
    money: 'การรับเงิน',
    full: 'เต็มจำนวน',
    total: 'ยอดค้างที่เลือก',
    taken: 'ตัดชำระ',
    left: 'ค้างหลังชำระ',
    autoAgain: 'ตัดอัตโนมัติอีกครั้ง',
    confirm: 'รับเงิน {{amount}} บาท และออกใบเสร็จ',
    again: 'รับชำระรายการใหม่',
    split: 'แยกใบเสร็จตามผู้ชำระ',
    splitHint: 'ผู้ชำระละใบ รับเต็มจำนวน',
    runTitle: 'รับเงินรอบส่ง',
    run: 'รอบส่ง {{number}}',
    receiptNo: 'ใบที่ {{n}}',
    switchFirst: 'บิลต้นทางจ่าย: ติ๊กเปลี่ยนเป็นปลายทางจ่ายใต้บิล ถ้าผู้รับจ่ายแทน หรือกด ✕ เอาออก',
    cash: 'เงินสดที่ต้องได้',
    transferred: 'ยอดโอน',
    received: 'เงินสดที่รับ',
    receipts: 'ใบเสร็จ',
    confirmSplit: 'ออกใบเสร็จ {{count}} ใบ · {{amount}} บาท',
    doneSplit: 'ออกใบเสร็จแล้ว {{count}} ใบ',
    backToRun: 'กลับไปรอบส่ง',
  },
  receipt: {
    title: 'ใบเสร็จ',
    plural: 'ใบเสร็จ',
    create: 'ออกใบเสร็จ',
    fields: {
      number: 'เลขที่',
      issuedAt: 'วันที่',
      branchId: 'สาขา',
      payerName: 'ผู้ชำระ',
      lines: 'ยอดแต่ละบิล',
      collectedBy: 'ผู้รับเงิน',
      collectedByUserId: 'ผู้รับเงิน (ผู้ใช้)',
      waybillIds: 'บิลงานขนส่ง',
      shipmentIds: 'งานเหมาคัน',
      jobLines: 'ยอดแต่ละงาน',
      payments: 'รายการรับเงิน',
      refundMethod: 'คืนเงินส่วนเกินเป็น',
      refundReference: 'เลขอ้างอิงการคืนเงิน',
      refundSlipId: 'สลิปการคืนเงิน',
      method: 'วิธีชำระ',
      amount: 'ยอดที่ต้องชำระ',
      received: 'รับเงินรวม',
      refund: 'เงินทอน / คืนเงิน',
      status: 'สถานะ',
      issuedBy: 'ผู้ออกใบเสร็จ',
      payerTaxId: 'เลขประจำตัวผู้เสียภาษี',
      payerBranch: 'สาขา (00000 = สำนักงานใหญ่)',
      payerAddress: 'ที่อยู่ (เลขที่ อาคาร ถนน)',
      payerProvince: 'ตำบล อำเภอ จังหวัด',
      payerDistrict: 'อำเภอ / เขต',
      payerSubdistrict: 'ตำบล / แขวง',
      payerPostcode: 'รหัสไปรษณีย์',
      withheld: 'ลูกค้าหัก ณ ที่จ่าย 1%',
      whtAmount: 'หัก ณ ที่จ่าย 1%',
      whtCertNo: 'เล่มที่ / เลขที่ 50 ทวิ',
      whtCertFileId: 'รูปใบ 50 ทวิ',
      whtStatus: 'ใบ 50 ทวิ',
      paidOn: 'วันที่รับเงินจริง',
      manualNo: 'เลขที่ใบเสร็จมือ',
      notes: 'หมายเหตุ',
      customerReceiptId: 'ใบเสร็จใส่ชื่อลูกค้า',
    },
    options: {
      method: { cash: 'เงินสด', transfer: 'โอน / QR', mixed: 'หลายช่องทาง' },
      refundMethod: { cash: 'เงินทอน (เงินสด)', transfer: 'โอนคืน' },
      status: { draft: 'ร่าง', issued: 'ใช้งาน', cancelled: 'ยกเลิก' },
      whtStatus: { pending: 'รอใบ 50 ทวิ', received: 'ได้รับแล้ว' },
    },
    sections: { main: 'ใบเสร็จ', payer: 'ผู้ชำระ', payments: 'การรับเงิน', other: 'หมายเหตุ' },
    wht: {
      toggle: 'ลูกค้าหัก ณ ที่จ่าย 1%',
      hint: 'เฉพาะนิติบุคคล ลูกค้าจ่าย 99% แล้วให้ใบ 50 ทวิ',
      person: '{{name}} เป็นบุคคลธรรมดา หัก ณ ที่จ่ายไม่ได้',
      taxId: 'เลขผู้เสียภาษีของผู้หัก (ตามใบ 50 ทวิ)',
      taxIdInvalid: 'นิติบุคคลเท่านั้น: 13 หลัก ขึ้นต้นด้วย 0',
      certNo: 'เล่มที่ / เลขที่',
      cert: 'รูปใบ 50 ทวิ',
      later: 'ยังไม่มีใบก็รับเงินได้ ฝ่ายบัญชีจะตามเก็บใบ 50 ทวิ',
      small: 'ยอดต่ำกว่า 1,000 บาท ปกติลูกค้าไม่ต้องหัก',
      amount: 'หัก ณ ที่จ่าย 1%',
      net: 'ลูกค้าจ่ายจริง',
      attach: 'บันทึกใบ 50 ทวิ',
      attached: 'แนบใบ 50 ทวิ แล้ว',
      pending: 'ยังไม่ได้รับใบ 50 ทวิ',
      refund: 'ขอคืนภาษีหัก ณ ที่จ่าย',
    },
    payment: {
      method: 'ช่องทาง',
      amount: 'จำนวนเงิน',
      reference: 'เลขอ้างอิง / ธนาคาร',
      slip: 'สลิป',
      slipNeeded: 'แนบรูปสลิปของยอดโอน',
      proofRequired: 'บริษัทจ่ายเงินออก ต้องใส่เลขอ้างอิงหรือแนบรูปสลิปอย่างใดอย่างหนึ่ง',
      add: 'เพิ่มการรับเงิน',
      remove: 'ลบรายการ',
    },
    document: 'ใบเสร็จรับเงิน',
    actions: { print: 'พิมพ์ใบเสร็จ' },
    /** A receipt in the customer's name in place of this one (accounting.customerReceipt) */
    customerReceipt: {
      issue: 'ออกใบเสร็จใส่ชื่อลูกค้า',
      issued: 'ออกใบเสร็จใส่ชื่อลูกค้าแล้ว',
      hint: 'ลูกค้ากลับมาขอใบเสร็จในชื่อของตัวเองภายหลัง หรือข้อมูลบนใบนี้ผิด ฝ่ายบัญชีออกใบใหม่แทนใบนี้ ยอดเงินเท่าเดิม',
    },
    /** Made out to a company: its details on the receipt (the pay dialog's "ออกในนามบริษัท") */
    company: {
      toggle: 'ออกในนามบริษัท',
      hint: 'ใบเสร็จพิมพ์ชื่อ เลขผู้เสียภาษี สาขา และที่อยู่ของบริษัท ตรวจกับเอกสารของลูกค้า',
      name: 'ชื่อบริษัท (ตามที่จดทะเบียน)',
      forWht: 'หัก ณ ที่จ่ายได้เฉพาะนิติบุคคล ใบเสร็จจึงออกในนามบริษัท',
      branchHint: '00000 คือสำนักงานใหญ่',
      headOffice: 'สำนักงานใหญ่',
      branch: 'สาขา',
    },
    thanks: 'ขอบคุณที่ใช้บริการ',
    taxId: 'เลขผู้เสียภาษี',
  },
  refund: {
    title: 'ใบคืนเงิน',
    plural: 'ใบคืนเงิน',
    create: 'ขอคืนเงิน',
    fields: {
      number: 'เลขที่',
      waybillId: 'บิลงานขนส่ง',
      side: 'คืนให้',
      branchId: 'สาขา',
      receiptId: 'ใบเสร็จเดิม',
      payeeName: 'ผู้รับเงินคืน',
      amount: 'จำนวนเงินคืน',
      method: 'คืนเป็น',
      reason: 'เหตุผล',
      reference: 'เลขอ้างอิงการโอน',
      slipId: 'สลิปการโอน',
      status: 'สถานะ',
      requestedByUserId: 'ผู้ขอ',
      approvedByUserId: 'ผู้อนุมัติ',
      approvedAt: 'อนุมัติเมื่อ',
      paidByUserId: 'ผู้จ่ายคืน',
      paidAt: 'จ่ายคืนเมื่อ',
      kind: 'ประเภท',
      whtTaxId: 'เลขผู้เสียภาษีของผู้หัก',
      whtCertNo: 'เล่มที่ / เลขที่ 50 ทวิ',
      whtCertFileId: 'รูปใบ 50 ทวิ',
    },
    options: {
      kind: { overpaid: 'คืนส่วนที่จ่ายเกิน', wht: 'คืนภาษีหัก ณ ที่จ่าย' },
      side: { sender: 'ผู้ส่ง (ต้นทาง)', receiver: 'ผู้รับ (ปลายทาง)' },
      status: { draft: 'ร่าง', requested: 'รออนุมัติ', approved: 'อนุมัติแล้ว รอจ่ายคืน', paid: 'คืนเงินแล้ว', cancelled: 'ยกเลิก' },
    },
    sections: { main: 'ใบคืนเงิน', payout: 'การจ่ายคืน' },
    whtTitle: 'ขอคืนภาษีหัก ณ ที่จ่าย ใบเสร็จ {{number}}',
    whtHint: 'ลูกค้านิติบุคคลจ่ายเต็มแล้ว ส่งใบ 50 ทวิ มาขอคืน 1% ต้องแนบรูปใบ หัวหน้างานของสาขาอนุมัติก่อนจ่ายคืน',
    whtReason: 'ลูกค้าส่งใบ 50 ทวิ ขอคืนภาษีหัก ณ ที่จ่าย 1%',
    whtAmount: 'คืน 1% ของ {{amount}} บาท',
    overpaid: 'ลูกค้าจ่ายเกิน {{amount}} บาท จากการแก้ราคาหลังรับเงิน',
    ask: 'ขอคืนเงิน {{amount}} บาท',
    askTitle: 'ขอคืนเงิน บิล {{number}}',
    askHint: 'หัวหน้างานของสาขาอนุมัติก่อน แล้วจึงจ่ายคืนได้ ใบเสร็จเดิมยังอยู่ ไม่ถูกยกเลิก',
    asked: 'ส่งขออนุมัติคืนเงินแล้ว',
    approve: 'อนุมัติคืนเงิน',
    approved: 'อนุมัติคืนเงิน {{number}} แล้ว',
    notYours: 'คนขอคืนเงินอนุมัติเองไม่ได้ ต้องให้หัวหน้างานของสาขาอนุมัติ',
    pay: 'จ่ายคืนแล้ว',
    payCash: 'จ่ายเงินสดคืนจากเงินต้องนำส่งในถุงเงินของคุณ',
    payTransfer: 'โอนคืนแล้วใส่เลขอ้างอิงหรือแนบสลิป',
    paid: 'คืนเงิน {{number}} แล้ว',
    document: 'ใบคืนเงิน',
    original: 'อ้างถึงใบเสร็จ',
    signPayee: 'ผู้รับเงินคืน',
    signPayer: 'ผู้จ่ายเงินคืน',
  },
  businessType: {
    construction: 'วัสดุก่อสร้าง ฮาร์ดแวร์',
    agriculture: 'เกษตร ปุ๋ย ยา เมล็ดพันธุ์',
    grocery: 'ของชำ ของใช้ (โชห่วย ยี่ปั๊ว)',
    auto_parts: 'อะไหล่ ยางรถยนต์',
    electrical: 'เครื่องใช้ไฟฟ้า อุปกรณ์ไฟฟ้า',
    furniture: 'เฟอร์นิเจอร์ ของแต่งบ้าน',
    apparel: 'เสื้อผ้า สิ่งทอ',
    food_service: 'ร้านอาหาร โรงแรม',
    industrial: 'โรงงาน อุตสาหกรรม',
    chain_store: 'ห้าง เชนสโตร์',
    online_seller: 'ร้านค้าออนไลน์',
    individual: 'บุคคลทั่วไป',
    other: 'อื่น ๆ',
  },
  contact: {
    title: 'ผู้ติดต่อ',
    plural: 'ผู้ติดต่อ',
    create: 'เพิ่มผู้ติดต่อ',
    fields: {
      name: 'ชื่อ',
      registeredName: 'ชื่อออกใบเสร็จ (ตามทะเบียน)',
      phone: 'เบอร์โทร',
      idCard: 'เลขบัตร/พาสปอร์ต',
      address: 'ที่อยู่',
      province: 'ตำบล อำเภอ จังหวัด',
      district: 'อำเภอ',
      subdistrict: 'ตำบล',
      postcode: 'รหัสไปรษณีย์',
      taxId: 'เลขประจำตัวผู้เสียภาษี',
      branch: 'สาขา (00000 = สำนักงานใหญ่)',
      businessType: 'ประเภทธุรกิจ',
      notes: 'สิ่งที่ควรรู้',
    },
    sections: { main: 'ข้อมูลติดต่อ', address: 'ที่อยู่', other: 'อื่น ๆ' },
    merge: {
      action: 'รวมรายการซ้ำ',
      title: 'รวมผู้ติดต่อ {{count}} รายการ',
      keep: 'เลือกรายการที่เก็บไว้',
      body: 'ช่องที่รายการนี้ยังว่างได้ข้อมูลจากรายการอื่น สิ่งที่ควรรู้ของทุกรายการต่อกัน บิลที่ออกให้รายการอื่นย้ายมาที่รายการนี้ แล้วรายการอื่นหายจากสมุด',
      confirm: 'รวม',
      done: 'รวมเป็น {{name}} แล้ว',
    },
  },
  product: {
    title: 'สินค้า',
    plural: 'สินค้า',
    create: 'เพิ่มสินค้า',
    fields: { name: 'ชื่อสินค้า', unit: 'หน่วย', rate: 'อัตรา (บาท/ชิ้น)', weightKg: 'น้ำหนัก/ชิ้น (กก.)', status: 'สถานะ', notes: 'หมายเหตุ' },
    options: { status: { active: 'ใช้งาน', inactive: 'เลิกใช้' } },
    sections: { main: 'ข้อมูลสินค้า' },
  },
  service: {
    title: 'บริการเสริม',
    plural: 'บริการเสริม',
    options: { basis: { bill: 'ต่อบิล', piece: 'ต่อชิ้น', weight: 'ตามน้ำหนัก' } },
    line: {
      add: 'เพิ่มบริการเสริม',
      pick: 'เลือกบริการเสริม',
      none: 'ไม่มีบริการเสริม',
      remove: 'ลบบริการนี้',
      price: 'ราคา',
      amount: 'ค่าบริการ',
      freight: 'ค่าขนส่ง',
      services: 'บริการเสริม',
      total: 'ยอดรวม',
      perBill: '{{rate}} บาท/บิล',
      perPiece: '{{rate}} บาท/ชิ้น',
      perWeight: '{{rate}} บาท/{{step}} กก.',
      minimum: 'ขั้นต่ำ {{amount}}',
      vatIncluded: 'ราคารวม VAT แล้ว',
      quantity: { piece: 'จำนวนชิ้น', weight: 'น้ำหนักที่ขน' },
      units: { piece: 'ชิ้น', weight: 'กก.' },
    },
  },
  terms: {
    title: 'เงื่อนไขการขนส่ง',
    plural: 'เงื่อนไขการขนส่ง',
    print: {
      heading: 'เงื่อนไขการขนส่ง ฉบับ {{number}}',
      agree: 'ผู้ส่งได้อ่านและยอมรับเงื่อนไขการขนส่งฉบับ {{number}} ฉบับเต็มอ่านได้ที่ {{link}}',
      agreeJob: 'ลูกค้ายอมรับเงื่อนไขการขนส่งฉบับ {{number}} ฉบับเต็มอ่านได้ที่ {{link}}',
    },
    sign: {
      title: 'ผู้ส่งเซ็นยอมรับเงื่อนไข',
      intro: 'ให้ผู้ส่งอ่านข้อสำคัญของเงื่อนไขการขนส่งฉบับ {{number}} แล้วเซ็นในกรอบ',
      agree: 'ข้าพเจ้า {{name}} ได้อ่านและยอมรับเงื่อนไขการขนส่งฉบับ {{number}}',
      full: 'อ่านฉบับเต็ม',
      confirm: 'ยอมรับและเซ็น',
      signed: 'ผู้ส่งเซ็นยอมรับเงื่อนไขฉบับ {{number}}',
      unsigned: 'ผู้ส่งยังไม่ได้เซ็น',
    },
  },
  clockFor: {
    noBranch: 'บัญชีนี้ยังไม่มีสาขาประจำ',
    people: 'ลงเวลาแทน',
    peopleHint: 'สำหรับคนที่ไม่มีมือถือ กดเมื่อเห็นตัวต่อหน้า',
    confirm: 'ลงเวลา{{kind}}ให้ {{name}}?',
    confirmBody: 'บันทึกเวลา {{time}} น. โดยระบุว่าคุณเป็นคนลงให้ ลงแล้วแก้หรือลบไม่ได้',
    recorded: 'ลงเวลา{{kind}}ให้ {{name}} แล้ว',
  },
  vehicle: {
    title: 'รถ',
    plural: 'รถ',
    create: 'เพิ่มรถ',
    fields: {
      plate: 'ทะเบียน',
      province: 'จังหวัด',
      type: 'ประเภทรถ',
      capacityKg: 'รับน้ำหนักได้ (กก.)',
      capacityPallets: 'จุพาเลท',
      status: 'สถานะ',
      ownerDriverId: 'รถของคนขับรถร่วม',
      notes: 'หมายเหตุ',
    },
    options: {
      type: { pickup: 'กระบะ 4 ล้อ', truck6: '6 ล้อ', truck10: '10 ล้อ', trailer: 'หัวลาก', reefer: 'รถห้องเย็น' },
      status: { active: 'พร้อมใช้งาน', maintenance: 'ซ่อมบำรุง', inactive: 'เลิกใช้งาน' },
    },
    sections: { main: 'ข้อมูลรถ' },
  },
  driver: {
    title: 'พนักงานประจำรถ',
    plural: 'พนักงานประจำรถ',
    create: 'เพิ่มพนักงานประจำรถ',
    fields: {
      code: 'รหัส',
      name: 'ชื่อ-นามสกุล',
      kind: 'หน้าที่',
      phone: 'เบอร์โทร',
      licenseNo: 'เลขใบขับขี่',
      licenseExpiry: 'ใบขับขี่หมดอายุ',
      userId: 'บัญชีผู้ใช้',
      status: 'สถานะ',
      contractor: 'คนขับรถร่วม',
      vendorId: 'จ่ายค่าเที่ยวให้ (คู่ค้า)',
      tripPay: 'ค่าเที่ยวปกติ (บาท)',
      notes: 'หมายเหตุ',
    },
    options: { status: { active: 'ทำงาน', inactive: 'เลิกใช้' }, kind: { driver: 'คนขับ', helper: 'ผู้ช่วยคนขับ' } },
    sections: { main: 'ข้อมูลพนักงาน', contract: 'รถร่วม' },
    contractHint: 'คนขับรถร่วมไม่ใช่พนักงาน มากับรถของตัวเอง ได้ค่าเที่ยวทุกเที่ยวที่ส่งสำเร็จ ระบบตั้งหนี้ให้คู่ค้าที่เลือกไว้ หัก ณ ที่จ่าย 1%',
    invite: 'เชิญเข้าใช้แอพ',
    inviteHint: 'ส่งลิงก์ให้คนขับรถร่วมตั้งชื่อผู้ใช้และรหัสผ่าน ไม่ต้องกรอกใบสมัครงาน',
    hasAccount: 'มีบัญชีเข้าใช้แอพแล้ว',
    accountClosed: 'บัญชีเข้าใช้แอพถูกปิดแล้ว',
    letGo: {
      cashWarning: 'ยังถือเงินสดอยู่ {{amount}} บาท ให้นำส่งหรือคืนก่อนเลิกใช้',
      openDocs: 'มีเอกสารเงินสดที่ยังไม่เสร็จ {{count}} รายการ',
      assets: 'ยังถือทรัพย์สินของบริษัท {{count}} รายการ ให้รับคืนก่อนเลิกใช้',
      clear: 'ไม่มีเงินสดหรือทรัพย์สินค้าง',
      closes: 'บันทึกแล้วบัญชีของคนขับจะถูกปิดทันที เข้าระบบไม่ได้อีก ถ้ากลับมาวิ่งงานให้ผู้ดูแลระบบเปิดบัญชีให้',
      stays: 'บัญชีนี้ใช้ทำงานอื่นด้วย ระบบจึงไม่ปิดให้ ถ้าเลิกทำงานทั้งหมดให้ผู้ดูแลระบบปิดบัญชี',
    },
  },
  trip: {
    title: 'เที่ยวรถ',
    plural: 'เที่ยวรถ',
    create: 'เปิดเที่ยวรถ',
    fields: {
      number: 'เลขที่เที่ยว',
      date: 'วันที่',
      originBranchId: 'ขึ้นของที่',
      stops: 'จุดลงของ',
      vehicleId: 'รถ',
      driverId: 'คนขับ',
      bills: 'บิล',
      pieces: 'ชิ้น',
      shortPieces: 'ของขาด (ชิ้น)',
      costs: 'ค่าขนส่ง',
      contractorBillId: 'ใบตั้งหนี้ค่าขนส่ง',
      notes: 'หมายเหตุ',
    },
    sections: { main: 'ข้อมูลเที่ยวรถ' },
    stopsField: {
      add: 'เพิ่มจุดลงของ',
      hint: 'เรียงตามลำดับที่รถแวะ วิ่งตรงใส่จุดเดียว',
      none: 'ยังไม่มีจุดลงของ',
      moveUp: 'เลื่อนขึ้น',
      moveDown: 'เลื่อนลง',
      remove: 'เอาออก',
      reached: 'ขึ้น-ลงของแล้ว',
    },
    actions: { scan: 'ขึ้น-ลงของ', open: 'เปิดเที่ยว' },
    toMe: 'มาสาขาฉัน',
    fromMe: 'ออกจากสาขาฉัน',
    on: 'บนรถ {{bills}} บิล {{pieces}} ชิ้น',
    submitFirst: 'กด "บันทึกและเสนอ" เปิดเที่ยวก่อน แล้วจึงสแกนขึ้นของได้',
    board: 'ของบนรถ',
    boardEmpty: 'ยังไม่มีของบนรถ',
    dropAt: 'ลงที่ {{branch}}',
    cost: {
      title: 'ค่าขนส่ง',
      set: 'ตั้งค่าขนส่ง',
      edit: 'แก้ค่าขนส่ง',
      none: 'ยังไม่ได้ตั้งค่าขนส่ง',
      total: 'รวม',
      draft: '(ร่าง)',
      vendor: 'จ่ายให้',
      kind: 'รายการ',
      name: 'ชื่อรายการ',
      amount: 'จำนวนเงิน',
      remove: 'ลบรายการ',
      add: 'เพิ่มรายการ',
      notes: 'หมายเหตุถึงฝ่ายบัญชี',
      hint: 'ส่งเป็นใบตั้งหนี้รออนุมัติ รายการเดียวว่าค่าขนส่ง: {{lines}} แก้ได้จนกว่าจะอนุมัติ',
      send: 'ส่งอนุมัติ {{amount}} บาท',
      saved: 'ตั้งค่าขนส่ง {{amount}} บาทแล้ว ใบตั้งหนี้ {{number}} รออนุมัติ',
      locked: 'ใบตั้งหนี้อนุมัติแล้ว แก้ค่าขนส่งไม่ได้ ถ้าผิดให้ฝ่ายบัญชียกเลิกใบนั้นก่อน แล้วตั้งใหม่',
      kinds: { trip: 'ค่าเที่ยว', fuel: 'ค่าน้ำมัน', toll: 'ค่าทางด่วน', other: 'อื่นๆ' },
      advanced: 'เบิกล่วงหน้าไปแล้ว {{amount}} บาท ใส่ยอดเต็มรวมส่วนที่เบิก ฝ่ายบัญชีหักออกตอนจ่าย',
    },
    advance: {
      title: 'เบิกล่วงหน้า',
      ask: 'เบิกล่วงหน้า',
      what: 'เบิกเป็น',
      account: 'โอนเข้าบัญชี',
      noAccount: 'คู่ค้านี้ยังไม่มีบัญชีธนาคาร ให้ฝ่ายบัญชีใส่ในข้อมูลคู่ค้าก่อน',
      hint: 'ฝ่ายบัญชีโอนให้ก่อน หัก ณ ที่จ่าย {{rate}}% (โอนจริง {{paid}} บาท) แล้วหักออกจากค่าขนส่งของเที่ยวนี้ตอนจ่าย',
      send: 'ขอเบิก {{amount}} บาท',
      sent: 'ส่งคำขอเบิกล่วงหน้า {{amount}} บาทให้ฝ่ายบัญชีแล้ว',
      waiting: 'รอฝ่ายบัญชี',
      inBank: 'รอโอน',
      paid: 'โอนแล้ว',
      applied: 'หักแล้ว',
      closed: 'ใบตั้งหนี้จ่ายครบแล้ว แก้ค่าขนส่งและเบิกล่วงหน้าไม่ได้ ถ้าต้องจ่ายเพิ่ม ให้ฝ่ายบัญชีจ่ายจากแอพบัญชี',
    },
  },
  manifest: {
    title: 'ใบคุมรถ',
    plural: 'ใบคุมรถ',
    fields: {
      number: 'เลขที่ใบคุมรถ',
      issuedAt: 'ทำเมื่อ',
      kind: 'ใบคุมรถของ',
      tripId: 'เที่ยวรถ',
      runId: 'รอบส่ง',
      branchId: 'ออกจากสาขา',
      vehicleId: 'รถ',
      driverId: 'คนขับ',
      route: 'เส้นทาง',
      bills: 'บิล',
      pieces: 'ชิ้น',
      lines: 'บิลในใบคุมรถ',
      status: 'สถานะ',
      replacedById: 'ใบใหม่ที่ทำแทน',
      issuedBy: 'ผู้ทำ',
    },
    options: {
      status: { draft: 'ร่าง', issued: 'ใช้อยู่', replaced: 'มีใบใหม่แทนแล้ว', cancelled: 'ยกเลิก' },
      kind: { trip: 'เที่ยวรถ', run: 'รอบส่ง' },
    },
    print: 'พิมพ์ใบคุมรถ',
    make: 'ทำใบคุมรถ',
    makeAgain: 'ทำใบคุมรถใหม่',
    made: 'ทำใบคุมรถ {{number}} แล้ว',
    none: 'ยังไม่มีใบคุมรถของช่วงที่ออกจาก {{branch}}',
    noneRun: 'ยังไม่มีใบคุมรถของรอบนี้',
    changed: 'ใบคุมรถไม่ตรงกับของบนรถ: {{diff}}',
    added: 'ขึ้นเพิ่ม {{count}} บิล',
    removed: 'เอาลง {{count}} บิล',
    leftAt: 'ออกจาก {{branch}} · {{time}} · {{count}} บิล',
    empty: 'ยังไม่มีใบคุมรถ',
    driverPhone: 'เบอร์คนขับ',
    summary: 'ทั้งหมด {{bills}} บิล {{pieces}} ชิ้น',
    group: 'ลงที่ {{branch}} · {{bills}} บิล {{pieces}} ชิ้น',
    col: {
      receiver: 'ผู้รับ',
      district: 'อำเภอ',
      sender: 'ผู้ส่ง',
      payer: 'ผู้ชำระค่าขนส่ง',
      bill: 'เลขที่บิล',
      billDate: 'วันที่ออกบิล',
      loaded: 'ขึ้นรถ',
      unloaded: 'ลงรถ',
    },
    sign: { loader: 'ผู้จ่ายสินค้า', driver: 'คนขับ', receiver: 'ผู้รับสินค้า {{branch}}', date: 'วันที่ ____/____/________' },
  },
  deliveryRun: {
    title: 'รอบส่ง',
    plural: 'รอบส่ง',
    create: 'เปิดรอบส่ง',
    fields: {
      number: 'เลขที่รอบส่ง',
      date: 'วันที่',
      branchId: 'สาขาที่ส่ง',
      driverId: 'คนขับ',
      vehicleId: 'รถ',
      status: 'สถานะ',
      bills: 'บิล',
      delivered: 'ส่งสำเร็จ',
      failed: 'ส่งไม่สำเร็จ',
      startKm: 'เลขไมล์ออกรถ',
      endKm: 'เลขไมล์กลับถึงสาขา',
      distanceKm: 'ระยะทาง (กม.)',
      startKmFileId: 'รูปเลขไมล์ออกรถ',
      endKmFileId: 'รูปเลขไมล์กลับถึงสาขา',
      contractorPay: 'ค่าจ้างรถร่วม (ต่อรอบ)',
      contractorBillId: 'ใบตั้งหนี้ค่ารอบ',
      driverUserId: 'บัญชีคนขับ',
      notes: 'หมายเหตุ',
    },
    options: { status: { draft: 'ร่าง', open: 'กำลังส่ง', done: 'ส่งครบแล้ว', cancelled: 'ยกเลิก' } },
    sections: { main: 'ข้อมูลรอบส่ง', odometer: 'เลขไมล์' },
    odometer: {
      start: 'ออกรถ',
      end: 'กลับถึงสาขา',
      takeStart: 'ถ่ายเลขไมล์ก่อนออกรถ',
      takeEnd: 'ถ่ายเลขไมล์ตอนกลับถึงสาขา',
      reading: 'เลขไมล์ (กม.)',
      photo: 'ถ่ายรูปหน้าปัด',
      retake: 'ถ่ายใหม่',
      photoTaken: 'รูปเลขไมล์',
      needPhoto: 'ถ่ายรูปหน้าปัดเลขไมล์ก่อน',
      save: 'บันทึกเลขไมล์',
      saved: 'บันทึกเลขไมล์แล้ว',
      km: '{{km}} กม.',
      distance: 'ระยะทาง {{km}} กม.',
      hint: 'ใช้คิดค่าน้ำมัน บันทึกได้ครั้งเดียว ถ้าผิดให้พนักงานสาขาแก้',
    },
    actions: { scan: 'ขึ้นบิลเข้ารอบ', deliver: 'ส่งสำเร็จ', fail: 'ส่งไม่สำเร็จ', call: 'โทร', map: 'แผนที่', collect: 'เก็บเงิน' },
    submitFirst: 'กด "บันทึกและเสนอ" เปิดรอบส่งก่อน แล้วจึงสแกนบิลขึ้นรอบได้',
    bills: 'บิลในรอบนี้',
    empty: 'ยังไม่มีบิลในรอบนี้',
    progress: 'ส่งแล้ว {{done}}/{{total}}',
    owes: 'เก็บเงินปลายทาง {{amount}} บาท',
    goodToKnow: 'สิ่งที่ควรรู้',
    paid: 'ชำระแล้ว',
    failTitle: 'ส่งไม่สำเร็จ',
    failReason: 'เหตุผล',
    failNote: 'รายละเอียด',
    failConfirm: 'บันทึก นำของกลับสาขา',
    deliverTitle: 'ส่งสำเร็จ',
    collectFirst: 'เก็บเงินปลายทางก่อน',
    collectTitle: 'เก็บเงินปลายทาง',
    unpaidConfirm: 'ผู้รับยังไม่ได้จ่ายค่าขนส่ง {{amount}} บาท ถ้าจะส่งโดยไม่เก็บเงิน ใส่เหตุผล ระบบจะแจ้งหัวหน้างานของสาขา และบิลยังค้างจ่าย',
    unpaidReason: 'เหตุผลที่ส่งโดยไม่เก็บเงิน',
    unpaidGo: 'ส่งโดยไม่เก็บเงิน',
    receipt: 'ใบเสร็จ {{number}}',
    receiptCompany: 'ใบเสร็จ {{number}} ในนาม {{name}}',
    takeBack: 'เอาออกจากรอบ',
    putOut: 'บิล {{number}} ขึ้นรอบแล้ว',
    settle: 'รับเงินรอบส่ง {{amount}} บาท',
    settleHint: 'ปลายทางจ่าย {{count}} บิล',
    settleSwitch: 'ต้นทางจ่ายที่ยังค้าง {{count}} บิล ให้ผู้รับจ่ายแทนได้',
    settleWhy: {
      none: 'ไม่มีบิลในรอบนี้ที่ยังต้องเก็บเงิน',
      noRight: 'รับเงินรอบส่งได้เฉพาะคนที่ออกใบเสร็จได้',
      branch: 'รับเงินรอบส่งได้เฉพาะพนักงานของ {{branch}}',
    },
    deliverMany: {
      title: 'ส่งสำเร็จ {{count}} บิล',
      hint: 'บันทึกชื่อผู้รับตามบิลแต่ละใบ',
      photo: 'รูปหลักฐาน (ไม่บังคับ)',
      owing: 'ผู้รับยังต้องจ่ายค่าขนส่ง: {{numbers}} กดรับเงินรอบส่งก่อน หรือเอาบิลนั้นออกจากที่เลือก',
      done: 'ส่งสำเร็จ {{count}} บิล',
    },
    none: 'วันนี้ไม่มีรอบส่ง',
    left: 'เหลือ {{count}} บิล',
  },
  track: {
    title: 'การเดินทางของบิล',
    kinds: {
      load: 'ขึ้นรถ',
      unload: 'ลงรถ',
      out: 'ออกส่ง',
      back: 'เอาออกจากรอบส่ง',
      delivered: 'ส่งสำเร็จ',
      undelivered: 'ยกเลิกส่งมอบ',
      failed: 'ส่งไม่สำเร็จ',
      returned: 'ตีกลับ',
      unreturned: 'ยกเลิกการตีกลับ',
    },
    failReasons: {
      no_one: 'ไม่มีคนรับ',
      unreachable: 'ติดต่อไม่ได้',
      refused: 'ปฏิเสธรับ',
      wrong_address: 'ที่อยู่ไม่ถูกต้อง',
      closed: 'ร้านปิด',
      other: 'อื่นๆ',
    },
    short: 'ขาด {{count}} ชิ้น',
    offRoute: 'นอกเส้นทาง',
    notScanned: 'ยังไม่ได้สแกนขึ้นรถ',
    pieces: '{{count}} ชิ้น',
    atBranch: 'ที่ {{name}}',
    onTrip: 'บนรถเที่ยว {{number}}',
    onRun: 'ออกส่งรอบ {{number}}',
    receiver: 'ผู้รับ {{name}}',
    pod: 'หลักฐานการส่ง',
    signedBy: 'ลายเซ็นผู้รับ',
    from: 'รับมาจาก {{name}} (บันทึกว่าอยู่ที่นั่น)',
    unpaid: 'ส่งโดยยังไม่เก็บเงิน: {{reason}}',
    returnedAs: 'ไปต่อในบิลตีกลับ {{number}}',
  },
  scanStation: {
    load: 'ขึ้นรถ',
    unload: 'ลงรถ',
    out: 'ขึ้นรอบส่ง',
    hint: 'ส่องกล้องที่บาร์โค้ดหรือ QR บนบิล',
    wrongCode: 'นี่ไม่ใช่บิลงานขนส่ง ลองอีกครั้ง',
    noCamera: 'เปิดกล้องไม่ได้ พิมพ์เลขที่บิลหรือเลือกจากรายการแทนได้',
    manual: 'พิมพ์หรือยิงบาร์โค้ดเลขที่บิล',
    cameraOn: 'สแกนด้วยกล้อง',
    cameraOff: 'ปิดกล้อง',
    search: 'ค้นหาเลขที่บิล ผู้ส่ง หรือผู้รับ',
    filters: { payer: 'ผู้ชำระ', province: 'จังหวัดผู้รับ', district: 'อำเภอผู้รับ', stop: 'ลงที่' },
    sort: 'เรียงตาม',
    filter: 'ตัวกรอง',
    clearFilters: 'ล้างตัวกรอง',
    sorts: { route: 'เรียงตามเส้นทาง', newest: 'บิลใหม่ก่อน' },
    all: 'เลือกทั้งหมด {{count}} บิล',
    allShown: 'เลือกทั้งหมดที่แสดง {{count}} บิล',
    noneWaiting: 'ไม่มีบิลรอที่นี่',
    noneFound: 'ไม่พบบิลตามที่ค้นหรือกรอง',
    nothingHere: 'ยังไม่มีการขึ้น-ลงของที่นี่',
    loadedHere: 'ขึ้นรถที่นี่ {{count}} บิล',
    coming: 'บนรถมีของลงที่นี่ {{count}} บิล',
    loadedWhen: 'ขึ้น {{time}}',
    offHere: 'ลงที่นี่แล้ว {{time}}',
    unloadedWhen: 'ลง {{time}}',
    notListed: 'ไม่อยู่ในใบคุมรถ',
    manifestCheck: 'ใบคุมรถ {{number}}: ลงที่นี่ {{expected}} บิล รับเข้าแล้ว {{received}}',
    picked: 'เลือก {{count}} บิล · {{pieces}} ชิ้น',
    unloadAt: 'ลงที่ {{branch}}',
    found: 'พบบนรถ',
    alreadyOn: 'บิล {{number}} อยู่บนรถแล้ว ลงที่ {{branch}}',
    movedMany: '{{mode}} {{count}} บิลแล้ว',
    askTitle: 'ตรวจก่อนทำต่อ',
    confirmAnyway: '{{mode}}ต่อ',
    shortRecorded: 'บันทึกของขาด {{count}} ชิ้น แจ้งหัวหน้างานของสาขาแล้ว',
    here: 'ที่สาขา',
    columns: { waiting: 'รอขึ้นรถ', truck: 'บนรถ', off: 'ลงที่นี่แล้ว', runWaiting: 'รอขึ้นรอบ', run: 'ในรอบนี้' },
    warnings: {
      notOnTrip: 'บิลนี้ไม่ได้อยู่ในเที่ยวนี้',
      otherTrip: 'บิลนี้ยังอยู่บนรถเที่ยว {{number}}',
      offRoute: 'สาขานี้ไม่อยู่ในเส้นทางของบิล (ลงได้ แต่ระบบบันทึกว่านอกเส้นทาง)',
      tripOffRoute: 'เที่ยวนี้ไม่ผ่านเส้นทางของบิล',
      notHere: 'ระบบบันทึกว่าบิลนี้อยู่ที่ {{branch}}',
      otherBranch: 'บิลนี้ส่งโดย {{branch}} ไม่ใช่สาขานี้',
      pickup: 'ผู้รับเลือกมารับเองที่สาขา',
      offTruck: 'บิลนี้อยู่บนรถเที่ยว {{number}} บันทึกลงที่สาขานี้ให้แล้ว',
      onRun: 'บิลนี้ออกส่งอยู่ในรอบ {{number}}',
      alreadyHere: 'บิลนี้ลงที่นี่ครบแล้ว',
    },
  },
  scan: {
    fab: 'สแกน QR',
    title: 'สแกน QR บนใบงานหรือบิล',
    hint: 'ส่องกล้องที่ QR มุมขวาบนของใบงานหรือบิล',
    wrongCode: 'QR นี้ไม่ใช่ใบงานหรือบิล ลองอีกครั้ง',
    noCamera: 'เปิดกล้องไม่ได้ พิมพ์เลขที่งานหรือเลขบิลด้านล่างแทนได้',
    manual: 'หรือพิมพ์เลขที่งานหรือเลขบิล เช่น J6910-0182',
    open: 'เปิด',
    notFound: 'ไม่พบงานนี้ในงานของคุณ',
    finding: 'กำลังหาบิลนี้ในรอบส่งของคุณ…',
    notMine: 'บิลนี้ไม่ได้อยู่ในรอบส่งของคุณ',
    qrCaption: 'สแกนเพื่อเปิดงาน',
  },
  myJobs: {
    greeting: 'สวัสดีคุณ{{name}}',
    summary: 'วันนี้มี {{count}} งาน',
    current: 'งานตอนนี้',
    next: 'งานถัดไป',
    none: 'วันนี้ไม่มีงาน',
    today: 'วันนี้',
    active: 'กำลังส่ง',
    done: 'เสร็จแล้ว',
    eta: 'ถึงประมาณ {{time}}',
    pickedUpAt: 'รับสินค้าแล้ว {{time}}',
    podTitle: 'ยืนยันการส่งสินค้า',
    podPhoto: 'ถ่ายรูปสินค้าที่ส่ง',
    podRetake: 'ถ่ายใหม่',
    podReceiver: 'ชื่อผู้รับสินค้า',
    podSign: 'ลายเซ็นผู้รับ',
    podSignHint: 'ยื่นมือถือให้ผู้รับเซ็นในกรอบ',
    podNeedProof: 'ให้ผู้รับเซ็น หรือถ่ายรูปสินค้าที่ส่งไว้เป็นหลักฐาน',
    podConfirm: 'ยืนยันส่งสำเร็จ',
    pod: 'หลักฐานการส่ง',
    podSigned: 'ผู้รับเซ็นรับ',
    podPhotoTaken: 'รูปสินค้าที่ส่ง',
  },
  overview: {
    title: 'ภาพรวมวันนี้',
    allBranches: 'ทุกสาขา',
    booked: 'รับบิลวันนี้',
    bills: 'บิล',
    pieces: 'ชิ้น',
    fee: 'ค่าขนส่ง',
    taken: 'รับเงิน',
    underway: 'บิลที่ยังไม่ถึงผู้รับ',
    underwayAt: 'บิลที่อยู่ หรือสแกนล่าสุดที่ {{branch}}',
    stuck: 'บิลค้าง',
    stuckHint: 'ออกบิลมาแล้ว {{days}} วันขึ้นไป ยังไม่ถึงผู้รับ เก่าที่สุดก่อน',
    noStuck: 'ไม่มีบิลที่ค้างเกิน {{days}} วัน',
    days: '{{count}} วัน',
    runsOut: 'รอบส่งที่ยังออกอยู่',
    noRunsOut: 'ไม่มีรอบส่งที่ออกอยู่',
    runDone: 'ส่งแล้ว {{done}}/{{bills}}',
    runFailed: 'ไม่สำเร็จ {{count}}',
    charter: 'งานเหมาคันวันนี้',
    late: 'ล่าช้า {{count}} งาน',
    viewAll: 'ดูทั้งหมด',
  },
  reports: {
    title: 'รายงาน',
    waybills: {
      title: 'บิลงานขนส่ง',
      description: 'จำนวนบิล ชิ้น น้ำหนัก ค่าขนส่ง และเงินที่รับแล้ว ตามวัน เดือน สาขา จังหวัด ผู้ส่ง หรือสถานะ',
      count: 'จำนวนบิล',
      fields: { receiverProvince: 'จังหวัดผู้รับ', senderId: 'ผู้ส่ง', weightKg: 'น้ำหนัก (กก.)' },
    },
    daily: 'งานเหมาคันรายวัน',
    dailyDescription: 'จำนวนงานเหมาคันและรายได้ค่าขนส่งตามวันและสถานะ',
    jobsPerDay: 'จำนวนงานต่อวัน',
    revenuePerDay: 'รายได้ค่าขนส่งต่อวัน (บาท)',
    range: 'ช่วงวันที่',
    date: 'วันที่',
    total: 'งานทั้งหมด',
    delivered: 'ส่งสำเร็จ',
    cancelled: 'ยกเลิก',
    late: 'ล่าช้า',
    revenue: 'รายได้ (บาท)',
    sum: 'รวม',
  },
} as const

export const en = {
  app: { name: 'TMS', description: 'Waybills, dispatch, trips and delivery runs' },
  nav: {
    overview: 'Today',
    counter: 'Counter',
    transport: 'Trucks',
    shipments: 'Charter jobs',
    trips: 'Trips',
    runs: 'Delivery runs',
    manifests: 'Truck manifests',
    waybills: 'Waybills',
    receipts: 'Receipts',
    refunds: 'Refunds',
    unpaid: 'Unpaid at destination',
    payBills: 'Pay several bills',
    contacts: 'Contacts',
    products: 'Products',
    settings: 'Master data',
    late: 'Late',
    vehicles: 'Vehicles',
    drivers: 'Crew',
    reports: 'Reports',
  },
  shipment: {
    title: 'Charter job',
    plural: 'Charter jobs',
    create: 'New charter job',
    fields: {
      number: 'Job no.',
      customerId: 'Customer',
      pickupDate: 'Pickup date',
      pickupTime: 'Pickup',
      origin: 'Origin',
      destination: 'Destination',
      distanceKm: 'Distance (km)',
      cargo: 'Cargo',
      pallets: 'Pallets',
      weightKg: 'Weight (kg)',
      vehicleId: 'Vehicle',
      driverId: 'Driver',
      helperIds: 'Helpers',
      contractorPay: 'Contract driver’s pay',
      contractorBillId: 'Trip bill',
      status: 'Status',
      eta: 'ETA',
      price: 'Freight (THB)',
      services: 'Add-on services',
      servicesFee: 'Add-on services',
      total: 'Total',
      paid: 'Paid',
      paymentStatus: 'Payment',
      receiptIds: 'Receipts',
      termsId: 'Shipping terms',
      notes: 'Notes',
      deliveredAt: 'Delivered at',
      driverUserId: 'Driver account',
      route: 'Route',
      etaShort: 'ETA',
    },
    options: {
      status: {
        draft: 'Draft',
        pending: 'Unassigned',
        assigned: 'Assigned',
        picking: 'Picking up',
        in_transit: 'In transit',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
      },
      paymentStatus: { unpaid: 'Unpaid', partial: 'Part paid', paid: 'Paid' },
    },
    sections: { main: 'Job', route: 'Route', cargo: 'Cargo', assign: 'Assignment', services: 'Add-on services', other: 'Notes' },
    actions: {
      assign: 'Assign',
      start: 'Start job',
      pickedUp: 'Picked up',
      deliver: 'Delivered',
      deliverWithPhoto: 'Delivered · photo',
      call: 'Call',
      navigate: 'Navigate',
    },
    late: '{{minutes}} min late',
    remainingKm: '{{km}} km to go',
    unassigned: 'No vehicle yet',
    chooseVehicle: 'Choose vehicle',
    lateChip: 'Late',
    statusCard: 'Job status',
    nextStep: 'Next step',
    setStatus: 'Mark as “{{status}}”',
    printJob: 'Print job sheet',
    pay: {
      title: 'Payment',
      dialog: 'Take payment for job',
      take: 'Take payment',
      owed: 'Still owed',
      none: 'Nothing paid yet',
      ahead: 'Take it before the truck leaves too (a deposit), or part by part: a receipt each time',
      partial: 'Part payment: still owed on this job',
      noTotal: "Set the job's freight to take payment",
      submitFirst: 'Submit the job to take payment',
    },
    jobSheet: 'Transport job sheet',
    submitFirst: 'Submit the job to confirm it, then assign a truck and print the job sheet',
    receiverSign: 'Received by',
    driverSign: 'Driver',
    dispatcherSign: 'Dispatcher',
  },
  assign: {
    title: 'Assign',
    job: 'Unassigned job',
    vehicle: 'Vehicle',
    driver: 'Driver',
    confirm: 'Assign',
    done: '{{number}} assigned to {{plate}}',
    noPending: 'No unassigned jobs',
    contractorPay: 'Contract driver’s pay for this trip',
    contractorHint: 'A contract driver drives only their own truck: once delivered, the trip is billed to them, 1% withheld',
  },
  waybill: {
    title: 'Waybill',
    plural: 'Waybills',
    create: 'New waybill',
    fields: {
      number: 'Waybill no.',
      bookedAt: 'Booked at',
      payer: 'Freight paid by',
      originBranchId: 'Received at',
      originMode: 'Pickup',
      senderId: 'Sender contact',
      senderName: 'Sender',
      senderPhone: 'Sender phone',
      senderIdCard: 'Sender ID / passport',
      senderAddress: 'Sender address',
      senderProvince: 'Subdistrict, district, province',
      senderDistrict: 'Sender district',
      senderSubdistrict: 'Sender subdistrict',
      senderPostcode: 'Sender postcode',
      senderBusinessType: "Sender's business type",
      destMode: 'Delivery',
      destBranchId: 'Destination branch',
      receiverId: 'Receiver contact',
      receiverName: 'Receiver',
      receiverPhone: 'Receiver phone',
      receiverAddress: 'Receiver address',
      receiverProvince: 'Subdistrict, district, province',
      receiverDistrict: 'Receiver district',
      receiverSubdistrict: 'Receiver subdistrict',
      receiverPostcode: 'Receiver postcode',
      receiverBusinessType: "Receiver's business type",
      items: 'Goods',
      pieces: 'Pieces',
      weightKg: 'Total weight (kg)',
      services: 'Add-on services',
      servicesFee: 'Add-on services',
      fee: 'Total',
      termsId: 'Shipping terms',
      route: 'Route',
      currentBranchId: 'Now at',
      status: 'Status',
      paymentStatus: 'Payment',
      senderPaid: 'Paid by the sender',
      receiverPaid: 'Paid by the receiver',
      receiptIds: 'Receipts',
      trackingCode: 'Tracking code',
      returnId: 'Return bill',
      returnOfId: 'Returned from bill',
      receiverMoved: 'Receiver part moved to the return bill',
      declaredValue: 'Declared value (THB)',
      reference: 'Customer reference',
      notes: 'Notes',
      signing: 'Sender signed the terms',
      provinceColumn: 'Receiver province',
    },
    options: {
      payer: { sender: 'Origin (sender)', receiver: 'Destination (receiver)' },
      originMode: { dropoff: 'Customer drops off at the counter', pickup: 'We collect from the sender' },
      destMode: { door: 'Deliver to the address', branch: 'Receiver collects at a branch' },
      status: {
        draft: 'Draft',
        received: 'Received',
        in_transit: 'In transit',
        at_branch: 'At branch',
        out_for_delivery: 'Out for delivery',
        ready_for_pickup: 'Ready for pickup',
        delivered: 'Delivered',
        returned: 'Returned',
        cancelled: 'Cancelled',
      },
      paymentStatus: {
        unpaid: 'Unpaid',
        partial: 'Partly paid',
        paid: 'Paid',
        overpaid: 'Refund owed',
        moved: 'Moved to the return bill',
      },
    },
    sections: {
      booking: 'Booking',
      sender: 'Sender',
      receiver: 'Receiver',
      items: 'Goods',
      services: 'Add-on services',
      extra: 'More details',
    },
    chips: { owing: 'Owing' },
    tabs: { main: 'Main', extra: 'More details' },
    steps: { sender: 'Sender', receiver: 'Receiver', items: 'Parcels and fee', review: 'Check before saving' },
    review: {
      edit: 'Change',
      pickupAt: 'Collected at {{branch}}',
      fromBranch: 'Dropped at {{branch}}',
      pickedUp: 'Picked up from the sender',
      check: 'Check the names, phones and addresses with the customer, then save',
    },
    item: {
      name: 'Product',
      qty: 'Qty',
      unit: 'Unit',
      weightKg: 'Weight/piece (kg)',
      rate: 'Rate',
      amount: 'Freight',
      add: 'Add line',
      remove: 'Remove line',
      placeholder: 'Type a product name',
    },
    summary: {
      title: 'Summary',
      route: 'Route',
      noRoute: 'No truck route reaches the destination branch yet. Set it up under Branches.',
      noBranch: 'No branch delivers to this area yet. Pick the destination branch, or add the area to a branch.',
      notDelivered: '{{branch}} does not deliver to {{place}}: the receiver collects at a branch',
      pickBranch: 'Choose the branch the receiver collects from',
      deliver: 'Delivered to the receiver',
      collect: 'Receiver collects at the branch',
      direct: 'Delivered by this branch',
      auto: 'Automatic: {{name}}',
      needArea: "Enter the receiver's area to find the destination branch and route",
      collectAt: 'Pickup branch',
    },
    contact: {
      placeholder: 'Type a name or phone number',
      hint: 'Pick from the address book, or type a new name and it is saved for you',
      open: 'Open contact',
      linked: 'From the address book',
      new: 'New',
      newHint: 'Not in the address book yet: added when the bill is submitted',
      hasNotes: 'Has things good to know',
      goodToKnow: 'Good to know',
      add: 'Add what is good to know',
      edit: 'Edit what is good to know',
      editTitle: 'Good to know about {{name}}',
      notesPlaceholder: 'e.g. call before arriving, narrow lane: no 6-wheelers, closed on Sundays',
      savedTo: 'Kept on the contact: every bill of theirs and the delivery run show it',
      saved: 'Saved',
      atHouse: 'Delivered here before as {{name}}',
      didYouMean: 'Did you mean',
      or: 'or',
      why: { phone: 'Same phone', name: 'Similar name' },
      useThis: 'Use this one',
      sameTitle: 'Is {{party}} "{{name}}" someone already in the book?',
      sameBody: 'If so, the bill is made out to them: what is good to know comes along, and the book holds them once',
      notSame: 'No, add someone new',
    },
    area: { placeholder: 'Type a subdistrict, district, province or postcode', none: 'No such area' },
    actions: {
      pay: 'Take payment',
      print: 'Print waybill',
      printReceipt: 'Print receipt',
      openReceipt: 'Open receipt',
      handover: 'Delivered',
      undeliver: 'Undo handover',
      return: 'Send back',
      notDelivered: 'Not delivered',
      copyTrackLink: 'Copy tracking link',
    },
    trackLink: {
      copied: 'Tracking link copied: send it to the customer on LINE',
      hint: 'The customer sees how the bill stands without signing in',
    },
    return: {
      title: 'Send bill {{number}} back',
      intro: 'The goods go back to {{origin}} on a new bill: the sender becomes its receiver and pays the return freight',
      reason: 'Why it goes back',
      note: 'Details',
      freight: 'Return freight (THB)',
      freightHint: 'Enter 0 when the company carries it',
      moved: 'Outbound freight the receiver has not paid, {{amount}} THB, moves to the sender on the return bill',
      total: 'The return bill takes {{amount}} THB from the sender',
      confirm: 'Send back',
      done: 'Sent back as bill {{number}}',
      returnedAs: 'Sent back as bill {{number}}',
      returnOf: 'Sent back from bill {{number}}',
      lines: { freight: 'Return freight', carried: 'Outbound freight, bill {{number}}' },
      goodsAt: 'Goods are at',
      goodsAtMine: 'Goods are at {{branch}} (your branch)',
      onTruck: 'on a truck',
      onRun: 'out on a delivery run',
      atBranch: 'at {{branch}}',
      catchUp: 'The system still has this bill {{now}}: saving puts the goods at {{branch}}',
    },
    notDelivered: {
      title: 'Bill {{number}} not delivered',
      reason: 'Why it was not delivered',
      intro: 'The bill waits for the next delivery run at the branch the goods are at',
      introRun: 'The bill is out on a delivery run: it is recorded not delivered there and waits at that run’s branch',
      confirm: 'Record not delivered',
      done: 'Bill {{number}} recorded not delivered',
    },
    handover: {
      payFirst: 'The receiver still owes freight: take it and tick that they took the goods, which hands it over too',
      done: 'Bill {{number}} handed over',
      screenTitle: 'Receiver signs for the goods',
      screenStatement: 'I have received the goods of bill {{number}}, {{pieces}} pieces',
    },
    undeliver: {
      title: 'Undo the handover of bill {{number}}',
      intro:
        "For a handover recorded on the wrong bill or to the wrong person: the receiver's signature is taken off, the handover stays in the bill's journey",
      backOnRun: 'The bill is out on run {{number}} again: record how it went anew',
      backHere: 'The bill is out on this run again: record how it went anew',
      backAt: 'The bill waits at {{branch}} again',
      note: 'Why it is undone',
      confirm: 'Undo handover',
      done: 'Handover of bill {{number}} undone',
    },
    pay: {
      title: 'Take freight payment',
      amount: 'Amount due',
      method: 'Method',
      received: 'Cash received',
      change: 'Change',
      short: 'Not enough received',
      partial: 'Part payment: still owed on this bill',
      confirmPartial: 'Take part and issue the receipt',
      confirm: 'Take payment and issue receipt',
      done: 'Receipt {{number}} issued',
      atDestination: 'The receiver pays at the destination',
      submitFirst: 'Submit the waybill to take payment and print it',
      exact: 'Exact',
      shortBy: '{{amount}} THB short',
      bills: 'Waybills on this receipt ({{count}})',
      removeBill: 'Remove this waybill',
      sameCustomer: 'Unpaid, same customer',
      paySelected: 'Take payment ({{count}})',
      payerRequired: 'These bills have different payers: enter who paid',
      mixedPayers: '{{count}} payers',
      groupSender: 'Sender pays (origin)',
      groupReceiver: 'Receiver pays (destination)',
      switchToReceiver: 'Set to sender-paid: switch to receiver-paid and take it here',
      switchToSender: 'Set to receiver-paid: switch to sender-paid and take it here',
      elsewhere: "Can't be paid at this branch (another branch's bill)",
      paidPartSender: 'The sender paid part already: who pays cannot change. Take the rest at the origin branch or head office',
      paidPartReceiver: 'The receiver paid part already: who pays cannot change. Take the rest at the destination branch or head office',
      searchBill: 'Add a bill: number, name or phone',
      transferred: 'Amount transferred',
      delivered: 'The receiver took the goods (the bill is delivered)',
      receiptOf: 'Taken at branch {{branch}}, the money in your bag',
      receiptFor: 'A receipt of branch {{branch}}, the cash in the bag of {{name}}',
      holder: 'Taking it for',
      holderNone: 'Myself',
      paidOn: 'Day the customer paid',
      noBranch: 'Your account has no home branch yet: you cannot take payments',
      over: 'Over by',
      overTransfer: 'The transfer is {{amount}} THB more than what is due',
      shareOf: '{{side}} {{amount}} of {{fee}}',
    },
    parts: {
      sender: 'Sender pays',
      receiver: 'Receiver pays',
      paid: 'Paid',
      owed: 'Owed',
    },
    print: {
      original: 'Original',
      copy: 'Copy',
      paper: 'Paper',
      a4Hint: 'Two a sheet, cut along the dashes',
      a5Hint: 'One a sheet, landscape',
      paperSheets: '{{count}} sheets of paper',
      withOriginal: 'Print the original',
      copies: 'Copies',
      sheets: 'Print {{count}}',
      scan: 'Open in the app',
      track: 'Track the parcel',
      senderSign: 'Sender',
      staffSign: 'Received by',
      declared: 'Declared value',
      payAt: 'Paid at',
      pieces: 'pcs',
      goods: '{{pieces}} pcs · {{kg}} kg',
      service: 'Add-on',
      paidStamp: 'Paid',
      via: 'via {{stops}}',
    },
  },
  payBills: {
    title: 'Pay several bills',
    subtitle: "Find the customer's bills and enter what was received; part payments are fine, oldest bills first",
    bills: 'Bills being paid',
    search: 'Find bills: number, name or phone',
    empty: "No bills yet. Search by phone to bring in all of the customer's unpaid bills",
    owes: 'Owes',
    pay: 'Pay',
    others: 'Other unpaid bills of {{name}}',
    addAll: 'Add all ({{count}})',
    money: 'Payment',
    full: 'In full',
    total: 'Owed on these bills',
    taken: 'Paid now',
    left: 'Still owed after',
    autoAgain: 'Allocate automatically again',
    confirm: 'Take {{amount}} THB and issue receipt',
    again: 'Take another payment',
    split: 'One receipt per payer',
    splitHint: 'Each payer gets their own receipt, paid in full',
    runTitle: 'Run takings',
    run: 'Delivery run {{number}}',
    receiptNo: 'Receipt {{n}}',
    switchFirst: 'Sender-paid bills: tick the switch under the bill if the receiver paid instead, or take it out with ✕',
    cash: 'Cash to receive',
    transferred: 'Transferred',
    received: 'Cash received',
    receipts: 'Receipts',
    confirmSplit: 'Issue {{count}} receipts · {{amount}} THB',
    doneSplit: '{{count}} receipts issued',
    backToRun: 'Back to the run',
  },
  receipt: {
    title: 'Receipt',
    plural: 'Receipts',
    create: 'Issue receipt',
    fields: {
      number: 'No.',
      issuedAt: 'Date',
      branchId: 'Branch',
      payerName: 'Paid by',
      lines: 'Per bill',
      collectedBy: 'Money taken by',
      collectedByUserId: 'Money taken by (user)',
      waybillIds: 'Waybills',
      shipmentIds: 'Charter jobs',
      jobLines: 'Per job',
      payments: 'Payments',
      refundMethod: 'Give the excess back as',
      refundReference: 'Refund reference',
      refundSlipId: 'Refund slip',
      method: 'Method',
      amount: 'Amount due',
      received: 'Received',
      refund: 'Change / refund',
      status: 'Status',
      issuedBy: 'Issued by',
      payerTaxId: 'Tax ID',
      payerBranch: 'Branch (00000 = head office)',
      payerAddress: 'Address (number, building, road)',
      payerProvince: 'Subdistrict, district, province',
      payerDistrict: 'District',
      payerSubdistrict: 'Subdistrict',
      payerPostcode: 'Postcode',
      withheld: 'Customer withheld 1%',
      whtAmount: 'Withheld 1%',
      whtCertNo: '50 Tawi book / no.',
      whtCertFileId: '50 Tawi photo',
      whtStatus: '50 Tawi',
      paidOn: 'Paid on',
      manualNo: 'Handwritten receipt no.',
      notes: 'Notes',
      customerReceiptId: 'Receipt in the customer’s name',
    },
    options: {
      method: { cash: 'Cash', transfer: 'Transfer / QR', mixed: 'Several methods' },
      refundMethod: { cash: 'Cash change', transfer: 'Refund transfer' },
      status: { draft: 'Draft', issued: 'Valid', cancelled: 'Cancelled' },
      whtStatus: { pending: 'Awaiting 50 Tawi', received: 'Received' },
    },
    sections: { main: 'Receipt', payer: 'Paid by', payments: 'Payments', other: 'Notes' },
    wht: {
      toggle: 'The customer withholds 1%',
      hint: 'Companies only: they pay 99% and give a 50 Tawi certificate',
      person: '{{name}} is a person and cannot withhold tax',
      taxId: "Withholder's tax ID (on the 50 Tawi)",
      taxIdInvalid: 'Companies only: 13 digits starting with 0',
      certNo: 'Book / no.',
      cert: '50 Tawi photo',
      later: 'No certificate yet? Take the money: accounting follows it up',
      small: 'Under 1,000 THB the customer usually does not withhold',
      amount: 'Withheld 1%',
      net: 'The customer pays',
      attach: 'Save the 50 Tawi',
      attached: '50 Tawi attached',
      pending: '50 Tawi not received yet',
      refund: 'Give back the withheld tax',
    },
    payment: {
      method: 'Method',
      amount: 'Amount',
      reference: 'Reference / bank',
      slip: 'Slip',
      slipNeeded: 'Attach the photo of the transfer slip',
      proofRequired: 'Money paid out needs a reference or a slip photo',
      add: 'Add a payment',
      remove: 'Remove',
    },
    document: 'Receipt',
    actions: { print: 'Print receipt' },
    customerReceipt: {
      issue: 'Issue a receipt in the customer’s name',
      issued: 'Receipt in the customer’s name issued',
      hint: 'For a customer who comes back for a receipt in their own name, or when the details here are wrong: accounting issues one in place of this, for the same money',
    },
    company: {
      toggle: 'Made out to a company',
      hint: 'The receipt prints the company’s name, tax ID, branch and address: check them against the customer’s papers',
      name: 'Company name (as registered)',
      forWht: 'Only a company withholds, so the receipt is made out to it',
      branchHint: '00000 is the head office',
      headOffice: 'Head office',
      branch: 'Branch',
    },
    thanks: 'Thank you',
    taxId: 'Tax ID',
  },
  refund: {
    title: 'Refund',
    plural: 'Refunds',
    create: 'Ask for a refund',
    fields: {
      number: 'No.',
      waybillId: 'Waybill',
      side: 'Back to',
      branchId: 'Branch',
      receiptId: 'Original receipt',
      payeeName: 'Paid back to',
      amount: 'Refund',
      method: 'Paid back by',
      reason: 'Reason',
      reference: 'Transfer reference',
      slipId: 'Transfer slip',
      status: 'Status',
      requestedByUserId: 'Asked by',
      approvedByUserId: 'Approved by',
      approvedAt: 'Approved at',
      paidByUserId: 'Paid by',
      paidAt: 'Paid at',
      kind: 'Kind',
      whtTaxId: "Withholder's tax ID",
      whtCertNo: '50 Tawi book / no.',
      whtCertFileId: '50 Tawi photo',
    },
    options: {
      kind: { overpaid: 'Overpaid', wht: 'Withheld tax' },
      side: { sender: 'Sender (origin)', receiver: 'Receiver (destination)' },
      status: { draft: 'Draft', requested: 'Awaiting approval', approved: 'Approved, to pay', paid: 'Refunded', cancelled: 'Cancelled' },
    },
    sections: { main: 'Refund', payout: 'Paying it back' },
    whtTitle: 'Withheld tax back for receipt {{number}}',
    whtHint:
      'A company paid in full and brought a 50 Tawi for 1%. Attach its photo; a manager at the branch approves before it is paid back',
    whtReason: 'The customer brought a 50 Tawi for 1% withheld',
    whtAmount: '1% of {{amount}} THB',
    overpaid: 'The customer paid {{amount}} THB too much: the price was lowered after payment',
    ask: 'Refund {{amount}} THB',
    askTitle: 'Refund for waybill {{number}}',
    askHint: 'A manager at the branch approves it before it is paid back. The original receipt stays as it is',
    asked: 'Sent for approval',
    approve: 'Approve the refund',
    approved: 'Refund {{number}} approved',
    notYours: 'Whoever asked cannot approve it: a manager at the branch does',
    pay: 'Paid back',
    payCash: 'Pay the cash back from the collections in your money bag',
    payTransfer: 'Transfer it back, then add the reference or the slip',
    paid: 'Refund {{number}} paid',
    document: 'Refund',
    original: 'For receipt',
    signPayee: 'Received by',
    signPayer: 'Paid by',
  },
  businessType: {
    construction: 'Building materials, hardware',
    agriculture: 'Farm supplies, fertiliser, seeds',
    grocery: 'Grocery, household goods',
    auto_parts: 'Auto parts, tyres',
    electrical: 'Electrical, appliances',
    furniture: 'Furniture, home decor',
    apparel: 'Clothing, textiles',
    food_service: 'Restaurants, hotels',
    industrial: 'Factories, industry',
    chain_store: 'Chain stores',
    online_seller: 'Online seller',
    individual: 'Individual',
    other: 'Other',
  },
  contact: {
    title: 'Contact',
    plural: 'Contacts',
    create: 'New contact',
    fields: {
      name: 'Name',
      registeredName: 'Name on receipts (as registered)',
      phone: 'Phone',
      idCard: 'ID / passport',
      address: 'Address',
      province: 'Subdistrict, district, province',
      district: 'District',
      subdistrict: 'Subdistrict',
      postcode: 'Postcode',
      taxId: 'Tax ID',
      branch: 'Branch (00000 = head office)',
      businessType: 'Business type',
      notes: 'Good to know',
    },
    sections: { main: 'Contact', address: 'Address', other: 'Other' },
    merge: {
      action: 'Merge duplicates',
      title: 'Merge {{count}} contacts',
      keep: 'Choose the one to keep',
      body: 'It takes what it lacks from the others, keeps what is good to know of all of them, and bills made out to the others are made out to it; the others leave the book',
      confirm: 'Merge',
      done: 'Merged into {{name}}',
    },
  },
  product: {
    title: 'Product',
    plural: 'Products',
    create: 'New product',
    fields: { name: 'Name', unit: 'Unit', rate: 'Rate (THB/piece)', weightKg: 'Weight/piece (kg)', status: 'Status', notes: 'Notes' },
    options: { status: { active: 'Active', inactive: 'Retired' } },
    sections: { main: 'Product' },
  },
  service: {
    title: 'Add-on service',
    plural: 'Add-on services',
    options: { basis: { bill: 'Per bill', piece: 'Per piece', weight: 'By weight' } },
    line: {
      add: 'Add a service',
      pick: 'Choose a service',
      none: 'No add-on services',
      remove: 'Remove this service',
      price: 'Price',
      amount: 'Charge',
      freight: 'Freight',
      services: 'Add-on services',
      total: 'Total',
      perBill: '{{rate}} THB/bill',
      perPiece: '{{rate}} THB/piece',
      perWeight: '{{rate}} THB/{{step}} kg',
      minimum: 'min. {{amount}}',
      vatIncluded: 'Prices include VAT',
      quantity: { piece: 'Pieces', weight: 'Weight carried' },
      units: { piece: 'pcs', weight: 'kg' },
    },
  },
  terms: {
    title: 'Shipping terms',
    plural: 'Shipping terms',
    print: {
      heading: 'Shipping terms {{number}}',
      agree: 'The sender has read and accepts shipping terms {{number}}; the full text is at {{link}}',
      agreeJob: 'The customer accepts shipping terms {{number}}; the full text is at {{link}}',
    },
    sign: {
      title: 'Sender accepts the terms',
      intro: 'Let the sender read the key points of shipping terms {{number}}, then sign in the box',
      agree: 'I, {{name}}, have read and accept shipping terms {{number}}',
      full: 'Read the full text',
      confirm: 'Accept and sign',
      signed: 'The sender accepted terms {{number}}',
      unsigned: 'Not signed by the sender yet',
    },
  },
  clockFor: {
    noBranch: 'This account has no home branch',
    people: 'Clock for someone',
    peopleHint: 'For people without a phone, when they are in front of you',
    confirm: 'Clock {{kind}} for {{name}}?',
    confirmBody: 'Records {{time}}, noting that you did it for them. It cannot be edited or deleted afterwards.',
    recorded: 'Clocked {{kind}} for {{name}}',
  },
  vehicle: {
    title: 'Vehicle',
    plural: 'Vehicles',
    create: 'Add vehicle',
    fields: {
      plate: 'Plate',
      province: 'Province',
      type: 'Type',
      capacityKg: 'Capacity (kg)',
      capacityPallets: 'Pallets',
      status: 'Status',
      ownerDriverId: 'Contract driver’s own',
      notes: 'Notes',
    },
    options: {
      type: { pickup: 'Pickup', truck6: '6-wheel', truck10: '10-wheel', trailer: 'Tractor', reefer: 'Reefer' },
      status: { active: 'Available', maintenance: 'Maintenance', inactive: 'Retired' },
    },
    sections: { main: 'Vehicle' },
  },
  driver: {
    title: 'Crew member',
    plural: 'Crew',
    create: 'Add crew member',
    fields: {
      code: 'Code',
      name: 'Full name',
      kind: 'Role',
      phone: 'Phone',
      licenseNo: 'Licence no.',
      licenseExpiry: 'Licence expiry',
      userId: 'User account',
      status: 'Status',
      contractor: 'Contract driver',
      vendorId: 'Pay trips to (partner)',
      tripPay: 'Usual trip pay (baht)',
      notes: 'Notes',
    },
    options: { status: { active: 'Active', inactive: 'Inactive' }, kind: { driver: 'Driver', helper: 'Helper' } },
    sections: { main: 'Crew member', contract: 'Contract driver' },
    contractHint:
      'A contract driver is not on the staff and comes with their own truck: every delivered trip is billed to the partner chosen, 1% withheld',
    invite: 'Invite to the app',
    inviteHint: 'Send a link for the contract driver to choose a username and password: no job application',
    hasAccount: 'Has an account for the app',
    accountClosed: 'Their account for the app is closed',
    letGo: {
      cashWarning: 'Still holds {{amount}} baht in cash: to hand in or return before letting them go',
      openDocs: '{{count}} cash documents not finished',
      assets: 'Still holds {{count}} of the company’s items: take them back before letting them go',
      clear: 'No cash or company items outstanding',
      closes: 'Once saved, their account closes at once and they can no longer sign in. If they drive again, an admin reopens it',
      stays: 'This account is used for other work too, so it stays open: an admin closes it if they stop working altogether',
    },
  },
  trip: {
    title: 'Trip',
    plural: 'Trips',
    create: 'New trip',
    fields: {
      number: 'Trip no.',
      date: 'Date',
      originBranchId: 'Loads at',
      stops: 'Stops',
      vehicleId: 'Vehicle',
      driverId: 'Driver',
      bills: 'Bills',
      pieces: 'Pieces',
      shortPieces: 'Short (pieces)',
      costs: 'Transport costs',
      contractorBillId: 'Transport bill',
      notes: 'Notes',
    },
    sections: { main: 'Trip' },
    stopsField: {
      add: 'Add a stop',
      hint: 'In the order the truck calls; a direct run has one stop',
      none: 'No stops yet',
      moveUp: 'Move up',
      moveDown: 'Move down',
      remove: 'Remove',
      reached: 'Bills moved here',
    },
    actions: { scan: 'Load & unload', open: 'Open trip' },
    toMe: 'Coming to my branch',
    fromMe: 'Leaving my branch',
    on: '{{bills}} bills, {{pieces}} pieces on board',
    submitFirst: 'Press "Save and submit" to open the trip first, then scan bills on',
    board: 'On board',
    boardEmpty: 'Nothing on board yet',
    dropAt: 'Drops at {{branch}}',
    cost: {
      title: 'Transport costs',
      set: 'Write transport costs',
      edit: 'Change transport costs',
      none: 'No transport costs yet',
      total: 'Total',
      draft: '(draft)',
      vendor: 'Pay to',
      kind: 'Cost',
      name: 'What for',
      amount: 'Amount',
      remove: 'Remove',
      add: 'Add a cost',
      notes: 'Note for accounting',
      hint: 'Goes for approval as a bill with one line, transport: {{lines}}. It can be changed until it is approved',
      send: 'Send for approval: {{amount}} baht',
      saved: 'Transport costs of {{amount}} baht written, bill {{number}} awaiting approval',
      locked:
        'The bill is approved, so its costs no longer change. If they are wrong, accounting cancels it first and you write them again',
      kinds: { trip: 'Trip fee', fuel: 'Fuel', toll: 'Tolls', other: 'Other' },
      advanced: '{{amount}} baht already paid in advance: write the full costs, advance included; accounting takes it off when paying',
    },
    advance: {
      title: 'Advances',
      ask: 'Ask for an advance',
      what: 'For',
      account: 'Pay into',
      noAccount: 'This partner has no bank account yet: accounting adds one to the partner first',
      hint: 'Accounting pays it now less {{rate}}% withheld ({{paid}} baht transferred) and takes it off this trip’s transport costs when paying them',
      send: 'Ask for {{amount}} baht',
      sent: 'Advance of {{amount}} baht asked of accounting',
      waiting: 'With accounting',
      inBank: 'In the bank',
      paid: 'Paid',
      applied: 'Set off',
      closed:
        'The bill is paid in full, so its costs no longer change and no advance is asked. Anything more is paid by accounting in the accounting app',
    },
  },
  manifest: {
    title: 'Truck manifest',
    plural: 'Truck manifests',
    fields: {
      number: 'Manifest no.',
      issuedAt: 'Made',
      kind: 'Manifest of',
      tripId: 'Trip',
      runId: 'Delivery run',
      branchId: 'Leaving from',
      vehicleId: 'Vehicle',
      driverId: 'Driver',
      route: 'Route',
      bills: 'Bills',
      pieces: 'Pieces',
      lines: 'Bills on the manifest',
      status: 'Status',
      replacedById: 'Replaced by',
      issuedBy: 'Made by',
    },
    options: {
      status: { draft: 'Draft', issued: 'Current', replaced: 'Replaced', cancelled: 'Cancelled' },
      kind: { trip: 'Trip', run: 'Delivery run' },
    },
    print: 'Print manifest',
    make: 'Make a manifest',
    makeAgain: 'Make a new manifest',
    made: 'Manifest {{number}} made',
    none: 'No manifest yet for leaving {{branch}}',
    noneRun: 'No manifest yet for this run',
    changed: 'The manifest no longer matches the truck: {{diff}}',
    added: '{{count}} bills loaded since',
    removed: '{{count}} bills taken off since',
    leftAt: 'Left {{branch}} · {{time}} · {{count}} bills',
    empty: 'No manifests yet',
    driverPhone: "Driver's phone",
    summary: '{{bills}} bills, {{pieces}} pieces',
    group: 'Drops at {{branch}} · {{bills}} bills, {{pieces}} pieces',
    col: {
      receiver: 'Receiver',
      district: 'District',
      sender: 'Sender',
      payer: 'Freight paid by',
      bill: 'Bill no.',
      billDate: 'Bill date',
      loaded: 'Loaded',
      unloaded: 'Unloaded',
    },
    sign: { loader: 'Handed over by', driver: 'Driver', receiver: 'Received at {{branch}}', date: 'Date ____/____/________' },
  },
  deliveryRun: {
    title: 'Delivery run',
    plural: 'Delivery runs',
    create: 'New delivery run',
    fields: {
      number: 'Run no.',
      date: 'Date',
      branchId: 'Delivering branch',
      driverId: 'Driver',
      vehicleId: 'Vehicle',
      status: 'Status',
      bills: 'Bills',
      delivered: 'Delivered',
      failed: 'Not delivered',
      startKm: 'Odometer leaving',
      endKm: 'Odometer back',
      distanceKm: 'Distance (km)',
      startKmFileId: 'Odometer photo leaving',
      endKmFileId: 'Odometer photo back',
      contractorPay: 'Contract driver’s pay (per run)',
      contractorBillId: 'Run bill',
      driverUserId: 'Driver account',
      notes: 'Notes',
    },
    options: { status: { draft: 'Draft', open: 'Delivering', done: 'All done', cancelled: 'Cancelled' } },
    sections: { main: 'Delivery run', odometer: 'Odometer' },
    odometer: {
      start: 'Leaving',
      end: 'Back at the branch',
      takeStart: 'Photo the odometer before leaving',
      takeEnd: 'Photo the odometer back at the branch',
      reading: 'Odometer (km)',
      photo: 'Photo the dashboard',
      retake: 'Retake',
      photoTaken: 'Odometer photo',
      needPhoto: 'Take a photo of the odometer first',
      save: 'Save reading',
      saved: 'Odometer saved',
      km: '{{km}} km',
      distance: '{{km}} km driven',
      hint: 'Fuel is paid by it. Saved once; if it is wrong, branch staff correct it',
    },
    actions: { scan: 'Add bills to the run', deliver: 'Delivered', fail: 'Not delivered', call: 'Call', map: 'Map', collect: 'Collect' },
    submitFirst: 'Press "Save and submit" to open the run first, then scan bills onto it',
    bills: 'Bills on this run',
    empty: 'No bills on this run yet',
    progress: 'Delivered {{done}}/{{total}}',
    owes: 'Collect {{amount}} THB',
    goodToKnow: 'Good to know',
    paid: 'Paid',
    failTitle: 'Not delivered',
    failReason: 'Reason',
    failNote: 'Details',
    failConfirm: 'Save, bring it back',
    deliverTitle: 'Delivered',
    collectFirst: 'Collect the freight first',
    collectTitle: 'Collect the freight',
    unpaidConfirm:
      'The receiver has not paid the freight of {{amount}} THB. To deliver without collecting, say why: the branch’s managers are told and the bill stays owed',
    unpaidReason: 'Why deliver without collecting',
    unpaidGo: 'Deliver without collecting',
    receipt: 'Receipt {{number}}',
    receiptCompany: 'Receipt {{number}}, made out to {{name}}',
    takeBack: 'Take off the run',
    putOut: 'Bill {{number}} is on the run',
    settle: 'Run takings {{amount}} THB',
    settleHint: '{{count}} receiver-paid bills',
    settleSwitch: '{{count}} sender-paid bills still owed, the receiver may pay instead',
    settleWhy: {
      none: 'No bill on this run still owes freight',
      noRight: 'Only someone who issues receipts takes in run takings',
      branch: 'Only the people of {{branch}} take in its run takings',
    },
    deliverMany: {
      title: 'Deliver {{count}} bills',
      hint: 'Each to the receiver its bill names',
      photo: 'Proof photo (optional)',
      owing: 'Receivers still owe freight: {{numbers}}. Take in the run takings first, or untick those bills',
      done: '{{count}} bills delivered',
    },
    none: 'No delivery runs today',
    left: '{{count}} bills left',
  },
  track: {
    title: 'Where the bill went',
    kinds: {
      load: 'Loaded',
      unload: 'Unloaded',
      out: 'Out for delivery',
      back: 'Taken off the run',
      delivered: 'Delivered',
      undelivered: 'Handover undone',
      failed: 'Not delivered',
      returned: 'Sent back',
      unreturned: 'Return cancelled',
    },
    failReasons: {
      no_one: 'Nobody there',
      unreachable: 'Could not reach them',
      refused: 'Refused',
      wrong_address: 'Wrong address',
      closed: 'Closed',
      other: 'Other',
    },
    short: '{{count}} pieces short',
    offRoute: 'Off route',
    notScanned: 'Not scanned onto a truck yet',
    pieces: '{{count}} pieces',
    atBranch: 'At {{name}}',
    onTrip: 'On trip {{number}}',
    onRun: 'Out on run {{number}}',
    receiver: 'Received by {{name}}',
    pod: 'Proof of delivery',
    signedBy: "Receiver's signature",
    from: 'Taken from {{name}} (recorded there)',
    unpaid: 'Delivered unpaid: {{reason}}',
    returnedAs: 'Goes on as return bill {{number}}',
  },
  scanStation: {
    load: 'Load',
    unload: 'Unload',
    out: 'Put on run',
    hint: 'Point the camera at the barcode or QR on the bill',
    wrongCode: 'This is not a waybill. Try again',
    noCamera: 'The camera did not open. Type the bill number or pick from the list instead',
    manual: 'Type or scan the bill number',
    cameraOn: 'Scan with the camera',
    cameraOff: 'Camera off',
    search: 'Find a bill number, sender or receiver',
    filters: { payer: 'Paid by', province: 'Receiver province', district: 'Receiver district', stop: 'Drops at' },
    sort: 'Sort',
    filter: 'Filters',
    clearFilters: 'Clear filters',
    sorts: { route: 'Along the route', newest: 'Newest first' },
    all: 'Pick all {{count}} bills',
    allShown: 'Pick all {{count}} shown',
    noneWaiting: 'No bills waiting here',
    noneFound: 'No bills match',
    nothingHere: 'Nothing loaded or unloaded here yet',
    loadedHere: '{{count}} bills loaded here',
    coming: '{{count}} bills on the truck for here',
    loadedWhen: 'On {{time}}',
    offHere: 'Off here {{time}}',
    unloadedWhen: 'Off {{time}}',
    notListed: 'Not on the manifest',
    manifestCheck: 'Manifest {{number}}: {{expected}} bills for here, {{received}} taken in',
    picked: '{{count}} bills picked · {{pieces}} pieces',
    unloadAt: 'At {{branch}}',
    found: 'Found on the truck',
    alreadyOn: '{{number}} is on the truck already, off at {{branch}}',
    movedMany: '{{mode}}: {{count}} bills done',
    askTitle: 'Check before going on',
    confirmAnyway: '{{mode}} anyway',
    shortRecorded: '{{count}} pieces short recorded; the branch’s managers were told',
    here: 'At branch',
    columns: { waiting: 'Waiting to load', truck: 'On the truck', off: 'Off here', runWaiting: 'Waiting for a run', run: 'On this run' },
    warnings: {
      notOnTrip: 'This bill is not on this trip',
      otherTrip: 'This bill is still on trip {{number}}',
      offRoute: "This branch is not on the bill's route (allowed, recorded as off route)",
      tripOffRoute: "This trip does not follow the bill's route",
      notHere: 'The bill is recorded at {{branch}}',
      otherBranch: 'This bill is delivered by {{branch}}, not this branch',
      pickup: 'The receiver chose to collect it at the branch',
      offTruck: 'This bill was on trip {{number}}: recorded off at this branch',
      onRun: 'This bill is out on run {{number}}',
      alreadyHere: 'This bill is all unloaded here already',
    },
  },
  scan: {
    fab: 'Scan QR',
    title: 'Scan a job sheet or bill QR',
    hint: 'Point the camera at the QR in the top right of the job sheet or bill',
    wrongCode: 'This QR is not a job sheet or a bill. Try again.',
    noCamera: 'The camera could not start. Type the job or bill number below instead.',
    manual: 'Or type the job or bill number, e.g. J6910-0182',
    open: 'Open',
    notFound: 'This job is not one of yours',
    finding: 'Looking for this bill on your runs…',
    notMine: 'This bill is not on your runs',
    qrCaption: 'Scan to open the job',
  },
  myJobs: {
    greeting: 'Hello, {{name}}',
    summary: '{{count}} jobs today',
    current: 'Current job',
    next: 'Up next',
    none: 'No jobs today',
    today: 'Today',
    active: 'Active',
    done: 'Done',
    eta: 'ETA {{time}}',
    pickedUpAt: 'Picked up {{time}}',
    podTitle: 'Proof of delivery',
    podPhoto: 'Photo of the goods',
    podRetake: 'Take again',
    podReceiver: 'Received by',
    podSign: 'Receiver’s signature',
    podSignHint: 'Hand the phone to the receiver to sign in the box',
    podNeedProof: 'Have the receiver sign, or take a photo of the goods as proof',
    podConfirm: 'Confirm delivery',
    pod: 'Proof of delivery',
    podSigned: 'Signed for by the receiver',
    podPhotoTaken: 'Photo of the goods',
  },
  overview: {
    title: 'Today',
    allBranches: 'All branches',
    booked: 'Booked today',
    bills: 'bills',
    pieces: 'pieces',
    fee: 'Freight',
    taken: 'Taken',
    underway: 'Bills on their way',
    underwayAt: 'Bills at, or last scanned at, {{branch}}',
    stuck: 'Stuck bills',
    stuckHint: 'Booked {{days}} or more days ago and not with the receiver yet, oldest first',
    noStuck: 'No bills stuck over {{days}} days',
    days: '{{count}} days',
    runsOut: 'Delivery runs out',
    noRunsOut: 'No delivery runs out',
    runDone: 'Delivered {{done}}/{{bills}}',
    runFailed: 'Failed {{count}}',
    charter: 'Charter jobs today',
    late: 'Late: {{count}}',
    viewAll: 'View all',
  },
  reports: {
    title: 'Reports',
    waybills: {
      title: 'Waybills',
      description: 'Bills, pieces, weight, freight and what was taken, by day, month, branch, province, sender or status',
      count: 'Bills',
      fields: { receiverProvince: 'Receiver province', senderId: 'Sender', weightKg: 'Weight (kg)' },
    },
    daily: 'Daily shipments',
    dailyDescription: 'Jobs and freight revenue by day and status',
    jobsPerDay: 'Jobs per day',
    revenuePerDay: 'Freight revenue per day (THB)',
    range: 'Date range',
    date: 'Date',
    total: 'Jobs',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    late: 'Late',
    revenue: 'Revenue (THB)',
    sum: 'Total',
  },
} as const
